/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const requestReview = /* GraphQL */ `
  mutation RequestReview($request: AWSJSON!) {
    requestReview(request: $request)
  }
`;
export const stripeCreateCustomerForUser = /* GraphQL */ `
  mutation StripeCreateCustomerForUser($request: AWSJSON!) {
    stripeCreateCustomerForUser(request: $request)
  }
`;
export const stripeAttachPaymentMethod = /* GraphQL */ `
  mutation StripeAttachPaymentMethod($request: AWSJSON!) {
    stripeAttachPaymentMethod(request: $request)
  }
`;
export const stripeCreatePaymentIntent = /* GraphQL */ `
  mutation StripeCreatePaymentIntent($request: AWSJSON!) {
    stripeCreatePaymentIntent(request: $request)
  }
`;
export const maintainLeadTransaction = /* GraphQL */ `
  mutation MaintainLeadTransaction($request: AWSJSON!) {
    maintainLeadTransaction(request: $request)
  }
`;
export const respondToCustomerComment = /* GraphQL */ `
  mutation RespondToCustomerComment($request: AWSJSON!) {
    respondToCustomerComment(request: $request)
  }
`;
export const shareMediaAndCreateTask = /* GraphQL */ `
  mutation ShareMediaAndCreateTask($request: AWSJSON!) {
    shareMediaAndCreateTask(request: $request)
  }
`;
export const updateFeedBlast = /* GraphQL */ `
  mutation UpdateFeedBlast(
    $id: ID!
    $header: String!
    $details: String!
    $imageName: String!
    $imageType: String!
    $showAfterEpoch: Float
    $showUntilEpoch: Float
  ) {
    updateFeedBlast(
      id: $id
      header: $header
      details: $details
      imageName: $imageName
      imageType: $imageType
      showAfterEpoch: $showAfterEpoch
      showUntilEpoch: $showUntilEpoch
    )
  }
`;
export const deleteFeedBlast = /* GraphQL */ `
  mutation DeleteFeedBlast($id: ID!) {
    deleteFeedBlast(id: $id)
  }
`;
export const circleFeedBlast = /* GraphQL */ `
  mutation CircleFeedBlast(
    $circleID: String!
    $header: String!
    $details: String!
    $imageName: String!
    $imageType: String!
    $blastEvent: String!
    $userID: String!
    $chartType: String
    $chartData: String
    $alertMessage: String
    $alertDetails: String
    $createdBy: String!
    $ccUserID: String!
    $feedType: String
    $showAfterEpoch: Float
    $showUntilEpoch: Float
  ) {
    circleFeedBlast(
      circleID: $circleID
      header: $header
      details: $details
      imageName: $imageName
      imageType: $imageType
      blastEvent: $blastEvent
      userID: $userID
      chartType: $chartType
      chartData: $chartData
      alertMessage: $alertMessage
      alertDetails: $alertDetails
      createdBy: $createdBy
      ccUserID: $ccUserID
      feedType: $feedType
      showAfterEpoch: $showAfterEpoch
      showUntilEpoch: $showUntilEpoch
    )
  }
`;
export const feedBlast = /* GraphQL */ `
  mutation FeedBlast(
    $header: String!
    $details: String!
    $imageName: String!
    $imageType: String!
    $blastEvent: String!
    $userID: String!
    $chartType: String
    $chartData: String
    $alertMessage: String
    $alertDetails: String
    $createdBy: String!
    $ccUserID: String!
    $feedType: String
    $showAfterEpoch: Float
    $showUntilEpoch: Float
  ) {
    feedBlast(
      header: $header
      details: $details
      imageName: $imageName
      imageType: $imageType
      blastEvent: $blastEvent
      userID: $userID
      chartType: $chartType
      chartData: $chartData
      alertMessage: $alertMessage
      alertDetails: $alertDetails
      createdBy: $createdBy
      ccUserID: $ccUserID
      feedType: $feedType
      showAfterEpoch: $showAfterEpoch
      showUntilEpoch: $showUntilEpoch
    )
  }
`;
export const circleApproverFeedBlast = /* GraphQL */ `
  mutation CircleApproverFeedBlast(
    $circleID: String!
    $header: String!
    $details: String!
    $imageName: String!
    $imageType: String!
    $blastEvent: String!
    $userID: String!
    $chartType: String
    $chartData: String
    $alertMessage: String
    $alertDetails: String
    $createdBy: String!
  ) {
    circleApproverFeedBlast(
      circleID: $circleID
      header: $header
      details: $details
      imageName: $imageName
      imageType: $imageType
      blastEvent: $blastEvent
      userID: $userID
      chartType: $chartType
      chartData: $chartData
      alertMessage: $alertMessage
      alertDetails: $alertDetails
      createdBy: $createdBy
    )
  }
`;
export const personAdminFunctions = /* GraphQL */ `
  mutation PersonAdminFunctions(
    $userID: ID!
    $username: String!
    $action: String!
    $users: AWSJSON
  ) {
    personAdminFunctions(
      userID: $userID
      username: $username
      action: $action
      users: $users
    )
  }
`;
export const acceptReward = /* GraphQL */ `
  mutation AcceptReward($rewardID: String!, $action: String!) {
    acceptReward(rewardID: $rewardID, action: $action)
  }
`;
export const completeMission = /* GraphQL */ `
  mutation CompleteMission($missionInfo: AWSJSON!) {
    completeMission(missionInfo: $missionInfo)
  }
`;
export const maintainDealV3 = /* GraphQL */ `
  mutation MaintainDealV3($dealInfo: AWSJSON!) {
    maintainDealV3(dealInfo: $dealInfo)
  }
`;
export const maintainProduct = /* GraphQL */ `
  mutation MaintainProduct($productInfo: AWSJSON!) {
    maintainProduct(productInfo: $productInfo)
  }
`;
export const deleteDealObject = /* GraphQL */ `
  mutation DeleteDealObject($id: ID!) {
    deleteDealObject(id: $id)
  }
`;
export const maintainPersonDefaultSchedule = /* GraphQL */ `
  mutation MaintainPersonDefaultSchedule($request: AWSJSON!) {
    maintainPersonDefaultSchedule(request: $request)
  }
`;
export const maintainPersonScheduleOverride = /* GraphQL */ `
  mutation MaintainPersonScheduleOverride($request: AWSJSON!) {
    maintainPersonScheduleOverride(request: $request)
  }
`;
export const assignMissionToCircleMembers = /* GraphQL */ `
  mutation AssignMissionToCircleMembers($missionID: ID!, $circleID: ID!) {
    assignMissionToCircleMembers(missionID: $missionID, circleID: $circleID)
  }
`;
export const saveMission = /* GraphQL */ `
  mutation SaveMission($mission: AWSJSON!, $doFeedBlast: Boolean) {
    saveMission(mission: $mission, doFeedBlast: $doFeedBlast)
  }
`;
export const saveGame = /* GraphQL */ `
  mutation SaveGame($mission: AWSJSON!, $doFeedBlast: Boolean) {
    saveGame(mission: $mission, doFeedBlast: $doFeedBlast)
  }
`;
export const modifyPerson = /* GraphQL */ `
  mutation ModifyPerson($person: AWSJSON!) {
    modifyPerson(person: $person)
  }
`;
export const createPerson = /* GraphQL */ `
  mutation CreatePerson($person: AWSJSON!) {
    createPerson(person: $person)
  }
`;
export const modifyCircleMember = /* GraphQL */ `
  mutation ModifyCircleMember(
    $circleID: ID!
    $personID: ID!
    $userIDs: [ID]
    $status: String
    $role: String
    $priority: Int
  ) {
    modifyCircleMember(
      circleID: $circleID
      personID: $personID
      userIDs: $userIDs
      status: $status
      role: $role
      priority: $priority
    )
  }
`;
export const deleteMissionFunction = /* GraphQL */ `
  mutation DeleteMissionFunction($missionID: ID!) {
    deleteMissionFunction(missionID: $missionID)
  }
`;
export const deleteGame = /* GraphQL */ `
  mutation DeleteGame($missionID: ID!) {
    deleteGame(missionID: $missionID)
  }
`;
export const maintainKPIGoals = /* GraphQL */ `
  mutation MaintainKPIGoals($KPIGoal: AWSJSON!) {
    maintainKPIGoals(KPIGoal: $KPIGoal)
  }
`;
export const listGiftcardCatalog = /* GraphQL */ `
  mutation ListGiftcardCatalog($orgID: String!) {
    listGiftcardCatalog(orgID: $orgID)
  }
`;
export const requestGiftcard = /* GraphQL */ `
  mutation RequestGiftcard($request: AWSJSON) {
    requestGiftcard(request: $request)
  }
`;
export const bookCalendarSlot = /* GraphQL */ `
  mutation BookCalendarSlot($request: AWSJSON) {
    bookCalendarSlot(request: $request)
  }
`;
export const deleteFeedItem = /* GraphQL */ `
  mutation DeleteFeedItem($request: AWSJSON) {
    deleteFeedItem(request: $request)
  }
`;
export const assignMissionToCircle = /* GraphQL */ `
  mutation AssignMissionToCircle($request: AWSJSON) {
    assignMissionToCircle(request: $request)
  }
`;
export const assignMissionToPerson = /* GraphQL */ `
  mutation AssignMissionToPerson($request: AWSJSON) {
    assignMissionToPerson(request: $request)
  }
`;
export const unAssignMissionFromCircle = /* GraphQL */ `
  mutation UnAssignMissionFromCircle($request: AWSJSON) {
    unAssignMissionFromCircle(request: $request)
  }
`;
export const unAssignMissionFromPerson = /* GraphQL */ `
  mutation UnAssignMissionFromPerson($request: AWSJSON) {
    unAssignMissionFromPerson(request: $request)
  }
`;
export const exportData = /* GraphQL */ `
  mutation ExportData($request: AWSJSON) {
    exportData(request: $request)
  }
`;
export const exportPins = /* GraphQL */ `
  mutation ExportPins($request: AWSJSON) {
    exportPins(request: $request)
  }
`;
export const tangoListCreditCards = /* GraphQL */ `
  mutation TangoListCreditCards($request: AWSJSON!) {
    tangoListCreditCards(request: $request)
  }
`;
export const tangoAddCreditCard = /* GraphQL */ `
  mutation TangoAddCreditCard($request: AWSJSON!) {
    tangoAddCreditCard(request: $request)
  }
`;
export const tangoRemoveCreditCard = /* GraphQL */ `
  mutation TangoRemoveCreditCard($request: AWSJSON!) {
    tangoRemoveCreditCard(request: $request)
  }
`;
export const tangoListCreditCardDeposits = /* GraphQL */ `
  mutation TangoListCreditCardDeposits($request: AWSJSON!) {
    tangoListCreditCardDeposits(request: $request)
  }
`;
export const tangoCreditCardDeposit = /* GraphQL */ `
  mutation TangoCreditCardDeposit($request: AWSJSON!) {
    tangoCreditCardDeposit(request: $request)
  }
`;
export const tangoListAccounts = /* GraphQL */ `
  mutation TangoListAccounts($request: AWSJSON!) {
    tangoListAccounts(request: $request)
  }
`;
export const tangoCreateAccount = /* GraphQL */ `
  mutation TangoCreateAccount($request: AWSJSON!) {
    tangoCreateAccount(request: $request)
  }
`;
export const tangoCreateCustomer = /* GraphQL */ `
  mutation TangoCreateCustomer($request: AWSJSON!) {
    tangoCreateCustomer(request: $request)
  }
`;
export const boostActivityFeedItem = /* GraphQL */ `
  mutation BoostActivityFeedItem($request: AWSJSON!) {
    boostActivityFeedItem(request: $request)
  }
`;
export const maintainStage = /* GraphQL */ `
  mutation MaintainStage($request: AWSJSON!) {
    maintainStage(request: $request)
  }
`;
export const maintainKPIRule = /* GraphQL */ `
  mutation MaintainKPIRule($request: AWSJSON!) {
    maintainKPIRule(request: $request)
  }
`;
export const giveGift = /* GraphQL */ `
  mutation GiveGift(
    $giveToUserID: ID!
    $points: Int
    $rewardID: ID
    $fromAdmin: Boolean!
  ) {
    giveGift(
      giveToUserID: $giveToUserID
      points: $points
      rewardID: $rewardID
      fromAdmin: $fromAdmin
    )
  }
`;
export const removeDealsAndPins = /* GraphQL */ `
  mutation RemoveDealsAndPins($request: AWSJSON!) {
    removeDealsAndPins(request: $request)
  }
`;
export const maintainDealOwners = /* GraphQL */ `
  mutation MaintainDealOwners($request: AWSJSON!) {
    maintainDealOwners(request: $request)
  }
`;
export const updateGameScores = /* GraphQL */ `
  mutation UpdateGameScores(
    $dimensionType: String!
    $newValues: AWSJSON!
    $newAPI: Boolean
    $missionID: ID
    $competitors: AWSJSON
  ) {
    updateGameScores(
      dimensionType: $dimensionType
      newValues: $newValues
      newAPI: $newAPI
      missionID: $missionID
      competitors: $competitors
    )
  }
`;
export const createArea = /* GraphQL */ `
  mutation CreateArea($request: AWSJSON!) {
    createArea(request: $request)
  }
`;
export const saveAuthToken = /* GraphQL */ `
  mutation SaveAuthToken($request: AWSJSON!) {
    saveAuthToken(request: $request)
  }
`;
export const chargeCreditCard = /* GraphQL */ `
  mutation ChargeCreditCard($request: AWSJSON!) {
    chargeCreditCard(request: $request)
  }
`;
export const chargeACH = /* GraphQL */ `
  mutation ChargeACH($request: AWSJSON!) {
    chargeACH(request: $request)
  }
`;
export const createPayEngineHash = /* GraphQL */ `
  mutation CreatePayEngineHash($request: AWSJSON!) {
    createPayEngineHash(request: $request)
  }
`;
export const createPayEngineMerchant = /* GraphQL */ `
  mutation CreatePayEngineMerchant($request: AWSJSON!) {
    createPayEngineMerchant(request: $request)
  }
`;
export const sendWaitlistEmail = /* GraphQL */ `
  mutation SendWaitlistEmail(
    $userID: ID!
    $userName: String!
    $userEmail: String!
    $orgName: String!
  ) {
    sendWaitlistEmail(
      userID: $userID
      userName: $userName
      userEmail: $userEmail
      orgName: $orgName
    )
  }
`;
export const upsertUserFeedback = /* GraphQL */ `
  mutation UpsertUserFeedback($request: AWSJSON!) {
    upsertUserFeedback(request: $request)
  }
`;
export const sendDamageReport = /* GraphQL */ `
  mutation SendDamageReport($request: AWSJSON!) {
    sendDamageReport(request: $request)
  }
`;
export const createAITraining = /* GraphQL */ `
  mutation CreateAITraining(
    $input: CreateAITrainingInput!
    $condition: ModelAITrainingConditionInput
  ) {
    createAITraining(input: $input, condition: $condition) {
      id
      orgID
      service
      name
      description
      prompt
      revision
      status
      users
      public
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateAITraining = /* GraphQL */ `
  mutation UpdateAITraining(
    $input: UpdateAITrainingInput!
    $condition: ModelAITrainingConditionInput
  ) {
    updateAITraining(input: $input, condition: $condition) {
      id
      orgID
      service
      name
      description
      prompt
      revision
      status
      users
      public
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteAITraining = /* GraphQL */ `
  mutation DeleteAITraining(
    $input: DeleteAITrainingInput!
    $condition: ModelAITrainingConditionInput
  ) {
    deleteAITraining(input: $input, condition: $condition) {
      id
      orgID
      service
      name
      description
      prompt
      revision
      status
      users
      public
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createSoloUtilityCompany = /* GraphQL */ `
  mutation CreateSoloUtilityCompany(
    $input: CreateSoloUtilityCompanyInput!
    $condition: ModelSoloUtilityCompanyConditionInput
  ) {
    createSoloUtilityCompany(input: $input, condition: $condition) {
      id
      orgID
      name
      short_name
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSoloUtilityCompany = /* GraphQL */ `
  mutation UpdateSoloUtilityCompany(
    $input: UpdateSoloUtilityCompanyInput!
    $condition: ModelSoloUtilityCompanyConditionInput
  ) {
    updateSoloUtilityCompany(input: $input, condition: $condition) {
      id
      orgID
      name
      short_name
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSoloUtilityCompany = /* GraphQL */ `
  mutation DeleteSoloUtilityCompany(
    $input: DeleteSoloUtilityCompanyInput!
    $condition: ModelSoloUtilityCompanyConditionInput
  ) {
    deleteSoloUtilityCompany(input: $input, condition: $condition) {
      id
      orgID
      name
      short_name
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAppMetric = /* GraphQL */ `
  mutation CreateAppMetric(
    $input: CreateAppMetricInput!
    $condition: ModelAppMetricConditionInput
  ) {
    createAppMetric(input: $input, condition: $condition) {
      id
      orgID
      createdAt
      action
      viewKey
      userID
      event
      count
      value
      updatedAt
      __typename
    }
  }
`;
export const updateAppMetric = /* GraphQL */ `
  mutation UpdateAppMetric(
    $input: UpdateAppMetricInput!
    $condition: ModelAppMetricConditionInput
  ) {
    updateAppMetric(input: $input, condition: $condition) {
      id
      orgID
      createdAt
      action
      viewKey
      userID
      event
      count
      value
      updatedAt
      __typename
    }
  }
`;
export const deleteAppMetric = /* GraphQL */ `
  mutation DeleteAppMetric(
    $input: DeleteAppMetricInput!
    $condition: ModelAppMetricConditionInput
  ) {
    deleteAppMetric(input: $input, condition: $condition) {
      id
      orgID
      createdAt
      action
      viewKey
      userID
      event
      count
      value
      updatedAt
      __typename
    }
  }
`;
export const createExportableData = /* GraphQL */ `
  mutation CreateExportableData(
    $input: CreateExportableDataInput!
    $condition: ModelExportableDataConditionInput
  ) {
    createExportableData(input: $input, condition: $condition) {
      id
      name
      description
      allowStartDate
      allowEndDate
      allowAll
      allowChangeEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateExportableData = /* GraphQL */ `
  mutation UpdateExportableData(
    $input: UpdateExportableDataInput!
    $condition: ModelExportableDataConditionInput
  ) {
    updateExportableData(input: $input, condition: $condition) {
      id
      name
      description
      allowStartDate
      allowEndDate
      allowAll
      allowChangeEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteExportableData = /* GraphQL */ `
  mutation DeleteExportableData(
    $input: DeleteExportableDataInput!
    $condition: ModelExportableDataConditionInput
  ) {
    deleteExportableData(input: $input, condition: $condition) {
      id
      name
      description
      allowStartDate
      allowEndDate
      allowAll
      allowChangeEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMessageThrottle = /* GraphQL */ `
  mutation CreateMessageThrottle(
    $input: CreateMessageThrottleInput!
    $condition: ModelMessageThrottleConditionInput
  ) {
    createMessageThrottle(input: $input, condition: $condition) {
      id
      lastReceivedTmst
      lastSentTmst
      throttledMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMessageThrottle = /* GraphQL */ `
  mutation UpdateMessageThrottle(
    $input: UpdateMessageThrottleInput!
    $condition: ModelMessageThrottleConditionInput
  ) {
    updateMessageThrottle(input: $input, condition: $condition) {
      id
      lastReceivedTmst
      lastSentTmst
      throttledMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMessageThrottle = /* GraphQL */ `
  mutation DeleteMessageThrottle(
    $input: DeleteMessageThrottleInput!
    $condition: ModelMessageThrottleConditionInput
  ) {
    deleteMessageThrottle(input: $input, condition: $condition) {
      id
      lastReceivedTmst
      lastSentTmst
      throttledMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCircleLevel = /* GraphQL */ `
  mutation CreateCircleLevel(
    $input: CreateCircleLevelInput!
    $condition: ModelCircleLevelConditionInput
  ) {
    createCircleLevel(input: $input, condition: $condition) {
      id
      name
      description
      levelNum
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circles {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateCircleLevel = /* GraphQL */ `
  mutation UpdateCircleLevel(
    $input: UpdateCircleLevelInput!
    $condition: ModelCircleLevelConditionInput
  ) {
    updateCircleLevel(input: $input, condition: $condition) {
      id
      name
      description
      levelNum
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circles {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteCircleLevel = /* GraphQL */ `
  mutation DeleteCircleLevel(
    $input: DeleteCircleLevelInput!
    $condition: ModelCircleLevelConditionInput
  ) {
    deleteCircleLevel(input: $input, condition: $condition) {
      id
      name
      description
      levelNum
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circles {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createLeadArea = /* GraphQL */ `
  mutation CreateLeadArea(
    $input: CreateLeadAreaInput!
    $condition: ModelLeadAreaConditionInput
  ) {
    createLeadArea(input: $input, condition: $condition) {
      id
      orgID
      name
      location {
        lat
        lon
        __typename
      }
      purchaseDate
      quantityOfLeads
      remainingLeads
      minimumPurchaseQuantity
      perLeadPrice
      daysToExpire
      initialPurchaseQuantity
      initialPurchasePrice
      totalCost
      pricePerLead
      leads {
        nextToken
        __typename
      }
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      transactions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateLeadArea = /* GraphQL */ `
  mutation UpdateLeadArea(
    $input: UpdateLeadAreaInput!
    $condition: ModelLeadAreaConditionInput
  ) {
    updateLeadArea(input: $input, condition: $condition) {
      id
      orgID
      name
      location {
        lat
        lon
        __typename
      }
      purchaseDate
      quantityOfLeads
      remainingLeads
      minimumPurchaseQuantity
      perLeadPrice
      daysToExpire
      initialPurchaseQuantity
      initialPurchasePrice
      totalCost
      pricePerLead
      leads {
        nextToken
        __typename
      }
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      transactions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteLeadArea = /* GraphQL */ `
  mutation DeleteLeadArea(
    $input: DeleteLeadAreaInput!
    $condition: ModelLeadAreaConditionInput
  ) {
    deleteLeadArea(input: $input, condition: $condition) {
      id
      orgID
      name
      location {
        lat
        lon
        __typename
      }
      purchaseDate
      quantityOfLeads
      remainingLeads
      minimumPurchaseQuantity
      perLeadPrice
      daysToExpire
      initialPurchaseQuantity
      initialPurchasePrice
      totalCost
      pricePerLead
      leads {
        nextToken
        __typename
      }
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      transactions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createLead = /* GraphQL */ `
  mutation CreateLead(
    $input: CreateLeadInput!
    $condition: ModelLeadConditionInput
  ) {
    createLead(input: $input, condition: $condition) {
      id
      leadAreaID
      leadArea {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      orgID
      product
      whenPurchased
      assignedUserIDs
      assignedDate
      addressID
      dealID
      leadFlexFields
      status
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      address {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateLead = /* GraphQL */ `
  mutation UpdateLead(
    $input: UpdateLeadInput!
    $condition: ModelLeadConditionInput
  ) {
    updateLead(input: $input, condition: $condition) {
      id
      leadAreaID
      leadArea {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      orgID
      product
      whenPurchased
      assignedUserIDs
      assignedDate
      addressID
      dealID
      leadFlexFields
      status
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      address {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteLead = /* GraphQL */ `
  mutation DeleteLead(
    $input: DeleteLeadInput!
    $condition: ModelLeadConditionInput
  ) {
    deleteLead(input: $input, condition: $condition) {
      id
      leadAreaID
      leadArea {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      orgID
      product
      whenPurchased
      assignedUserIDs
      assignedDate
      addressID
      dealID
      leadFlexFields
      status
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      address {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createIntegration = /* GraphQL */ `
  mutation CreateIntegration(
    $input: CreateIntegrationInput!
    $condition: ModelIntegrationConditionInput
  ) {
    createIntegration(input: $input, condition: $condition) {
      id
      partner
      orgID
      partnerCode
      refreshToken
      accessToken
      expiration
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateIntegration = /* GraphQL */ `
  mutation UpdateIntegration(
    $input: UpdateIntegrationInput!
    $condition: ModelIntegrationConditionInput
  ) {
    updateIntegration(input: $input, condition: $condition) {
      id
      partner
      orgID
      partnerCode
      refreshToken
      accessToken
      expiration
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteIntegration = /* GraphQL */ `
  mutation DeleteIntegration(
    $input: DeleteIntegrationInput!
    $condition: ModelIntegrationConditionInput
  ) {
    deleteIntegration(input: $input, condition: $condition) {
      id
      partner
      orgID
      partnerCode
      refreshToken
      accessToken
      expiration
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createIntegrationXref = /* GraphQL */ `
  mutation CreateIntegrationXref(
    $input: CreateIntegrationXrefInput!
    $condition: ModelIntegrationXrefConditionInput
  ) {
    createIntegrationXref(input: $input, condition: $condition) {
      id
      orgID
      partnerID
      partnerKeyName
      partnerKeyValue
      ourKeyName
      ourKeyValue
      mappingJSON
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateIntegrationXref = /* GraphQL */ `
  mutation UpdateIntegrationXref(
    $input: UpdateIntegrationXrefInput!
    $condition: ModelIntegrationXrefConditionInput
  ) {
    updateIntegrationXref(input: $input, condition: $condition) {
      id
      orgID
      partnerID
      partnerKeyName
      partnerKeyValue
      ourKeyName
      ourKeyValue
      mappingJSON
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteIntegrationXref = /* GraphQL */ `
  mutation DeleteIntegrationXref(
    $input: DeleteIntegrationXrefInput!
    $condition: ModelIntegrationXrefConditionInput
  ) {
    deleteIntegrationXref(input: $input, condition: $condition) {
      id
      orgID
      partnerID
      partnerKeyName
      partnerKeyValue
      ourKeyName
      ourKeyValue
      mappingJSON
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDirectMessage = /* GraphQL */ `
  mutation CreateDirectMessage(
    $input: CreateDirectMessageInput!
    $condition: ModelDirectMessageConditionInput
  ) {
    createDirectMessage(input: $input, condition: $condition) {
      id
      thread_ts
      event_ts
      orgID
      direction
      userID
      message
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateDirectMessage = /* GraphQL */ `
  mutation UpdateDirectMessage(
    $input: UpdateDirectMessageInput!
    $condition: ModelDirectMessageConditionInput
  ) {
    updateDirectMessage(input: $input, condition: $condition) {
      id
      thread_ts
      event_ts
      orgID
      direction
      userID
      message
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteDirectMessage = /* GraphQL */ `
  mutation DeleteDirectMessage(
    $input: DeleteDirectMessageInput!
    $condition: ModelDirectMessageConditionInput
  ) {
    deleteDirectMessage(input: $input, condition: $condition) {
      id
      thread_ts
      event_ts
      orgID
      direction
      userID
      message
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createReviewRequest = /* GraphQL */ `
  mutation CreateReviewRequest(
    $input: CreateReviewRequestInput!
    $condition: ModelReviewRequestConditionInput
  ) {
    createReviewRequest(input: $input, condition: $condition) {
      id
      dealID
      orgID
      email
      phone
      message
      imageKeys
      expiresAt
      currentStatus
      createdBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateReviewRequest = /* GraphQL */ `
  mutation UpdateReviewRequest(
    $input: UpdateReviewRequestInput!
    $condition: ModelReviewRequestConditionInput
  ) {
    updateReviewRequest(input: $input, condition: $condition) {
      id
      dealID
      orgID
      email
      phone
      message
      imageKeys
      expiresAt
      currentStatus
      createdBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteReviewRequest = /* GraphQL */ `
  mutation DeleteReviewRequest(
    $input: DeleteReviewRequestInput!
    $condition: ModelReviewRequestConditionInput
  ) {
    deleteReviewRequest(input: $input, condition: $condition) {
      id
      dealID
      orgID
      email
      phone
      message
      imageKeys
      expiresAt
      currentStatus
      createdBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createIntegrationConfig = /* GraphQL */ `
  mutation CreateIntegrationConfig(
    $input: CreateIntegrationConfigInput!
    $condition: ModelIntegrationConfigConditionInput
  ) {
    createIntegrationConfig(input: $input, condition: $condition) {
      id
      integrationKey
      orgID
      crmName
      categoryID
      stageMapping
      fieldMapping
      configOptions
      isActive
      apiKey
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateIntegrationConfig = /* GraphQL */ `
  mutation UpdateIntegrationConfig(
    $input: UpdateIntegrationConfigInput!
    $condition: ModelIntegrationConfigConditionInput
  ) {
    updateIntegrationConfig(input: $input, condition: $condition) {
      id
      integrationKey
      orgID
      crmName
      categoryID
      stageMapping
      fieldMapping
      configOptions
      isActive
      apiKey
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteIntegrationConfig = /* GraphQL */ `
  mutation DeleteIntegrationConfig(
    $input: DeleteIntegrationConfigInput!
    $condition: ModelIntegrationConfigConditionInput
  ) {
    deleteIntegrationConfig(input: $input, condition: $condition) {
      id
      integrationKey
      orgID
      crmName
      categoryID
      stageMapping
      fieldMapping
      configOptions
      isActive
      apiKey
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInboxEvent = /* GraphQL */ `
  mutation CreateInboxEvent(
    $input: CreateInboxEventInput!
    $condition: ModelInboxEventConditionInput
  ) {
    createInboxEvent(input: $input, condition: $condition) {
      id
      orgID
      flexAttributes
      dealID
      sharedMediaID
      eventType
      status
      createdBy
      ownerID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      createdByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      owner {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateInboxEvent = /* GraphQL */ `
  mutation UpdateInboxEvent(
    $input: UpdateInboxEventInput!
    $condition: ModelInboxEventConditionInput
  ) {
    updateInboxEvent(input: $input, condition: $condition) {
      id
      orgID
      flexAttributes
      dealID
      sharedMediaID
      eventType
      status
      createdBy
      ownerID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      createdByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      owner {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteInboxEvent = /* GraphQL */ `
  mutation DeleteInboxEvent(
    $input: DeleteInboxEventInput!
    $condition: ModelInboxEventConditionInput
  ) {
    deleteInboxEvent(input: $input, condition: $condition) {
      id
      orgID
      flexAttributes
      dealID
      sharedMediaID
      eventType
      status
      createdBy
      ownerID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      createdByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      owner {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createSMSConversation = /* GraphQL */ `
  mutation CreateSMSConversation(
    $input: CreateSMSConversationInput!
    $condition: ModelSMSConversationConditionInput
  ) {
    createSMSConversation(input: $input, condition: $condition) {
      id
      recipientNumber
      senderId
      reportID
      orgID
      contactID
      isDeleted
      createdAt
      updatedAt
      contact {
        id
        orgID
        companyID
        relatedContactID
        relationshipType
        firstName
        lastName
        phoneNumber
        email
        currentOwnerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateSMSConversation = /* GraphQL */ `
  mutation UpdateSMSConversation(
    $input: UpdateSMSConversationInput!
    $condition: ModelSMSConversationConditionInput
  ) {
    updateSMSConversation(input: $input, condition: $condition) {
      id
      recipientNumber
      senderId
      reportID
      orgID
      contactID
      isDeleted
      createdAt
      updatedAt
      contact {
        id
        orgID
        companyID
        relatedContactID
        relationshipType
        firstName
        lastName
        phoneNumber
        email
        currentOwnerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteSMSConversation = /* GraphQL */ `
  mutation DeleteSMSConversation(
    $input: DeleteSMSConversationInput!
    $condition: ModelSMSConversationConditionInput
  ) {
    deleteSMSConversation(input: $input, condition: $condition) {
      id
      recipientNumber
      senderId
      reportID
      orgID
      contactID
      isDeleted
      createdAt
      updatedAt
      contact {
        id
        orgID
        companyID
        relatedContactID
        relationshipType
        firstName
        lastName
        phoneNumber
        email
        currentOwnerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createSharedMedia = /* GraphQL */ `
  mutation CreateSharedMedia(
    $input: CreateSharedMediaInput!
    $condition: ModelSharedMediaConditionInput
  ) {
    createSharedMedia(input: $input, condition: $condition) {
      id
      orgID
      userID
      sharedBy
      dealID
      taskID
      mediaID
      sourceType
      sourceId
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      sharedByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateSharedMedia = /* GraphQL */ `
  mutation UpdateSharedMedia(
    $input: UpdateSharedMediaInput!
    $condition: ModelSharedMediaConditionInput
  ) {
    updateSharedMedia(input: $input, condition: $condition) {
      id
      orgID
      userID
      sharedBy
      dealID
      taskID
      mediaID
      sourceType
      sourceId
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      sharedByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteSharedMedia = /* GraphQL */ `
  mutation DeleteSharedMedia(
    $input: DeleteSharedMediaInput!
    $condition: ModelSharedMediaConditionInput
  ) {
    deleteSharedMedia(input: $input, condition: $condition) {
      id
      orgID
      userID
      sharedBy
      dealID
      taskID
      mediaID
      sourceType
      sourceId
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      sharedByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createSelfRegisteredUser = /* GraphQL */ `
  mutation CreateSelfRegisteredUser(
    $input: CreateSelfRegisteredUserInput!
    $condition: ModelSelfRegisteredUserConditionInput
  ) {
    createSelfRegisteredUser(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phoneNumber
      companyName
      companySize
      website
      orgID
      goals
      createdAt
      updatedAt
      invitees {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateSelfRegisteredUser = /* GraphQL */ `
  mutation UpdateSelfRegisteredUser(
    $input: UpdateSelfRegisteredUserInput!
    $condition: ModelSelfRegisteredUserConditionInput
  ) {
    updateSelfRegisteredUser(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phoneNumber
      companyName
      companySize
      website
      orgID
      goals
      createdAt
      updatedAt
      invitees {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteSelfRegisteredUser = /* GraphQL */ `
  mutation DeleteSelfRegisteredUser(
    $input: DeleteSelfRegisteredUserInput!
    $condition: ModelSelfRegisteredUserConditionInput
  ) {
    deleteSelfRegisteredUser(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phoneNumber
      companyName
      companySize
      website
      orgID
      goals
      createdAt
      updatedAt
      invitees {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createSelfRegisteredUserInvitee = /* GraphQL */ `
  mutation CreateSelfRegisteredUserInvitee(
    $input: CreateSelfRegisteredUserInviteeInput!
    $condition: ModelSelfRegisteredUserInviteeConditionInput
  ) {
    createSelfRegisteredUserInvitee(input: $input, condition: $condition) {
      id
      orgID
      referredByID
      contactInformation
      shortCode
      invitationTimestamps
      createdAt
      createdBy
      updatedAt
      lastUpdatedBy
      referredBy {
        id
        email
        firstName
        lastName
        phoneNumber
        companyName
        companySize
        website
        orgID
        goals
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateSelfRegisteredUserInvitee = /* GraphQL */ `
  mutation UpdateSelfRegisteredUserInvitee(
    $input: UpdateSelfRegisteredUserInviteeInput!
    $condition: ModelSelfRegisteredUserInviteeConditionInput
  ) {
    updateSelfRegisteredUserInvitee(input: $input, condition: $condition) {
      id
      orgID
      referredByID
      contactInformation
      shortCode
      invitationTimestamps
      createdAt
      createdBy
      updatedAt
      lastUpdatedBy
      referredBy {
        id
        email
        firstName
        lastName
        phoneNumber
        companyName
        companySize
        website
        orgID
        goals
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteSelfRegisteredUserInvitee = /* GraphQL */ `
  mutation DeleteSelfRegisteredUserInvitee(
    $input: DeleteSelfRegisteredUserInviteeInput!
    $condition: ModelSelfRegisteredUserInviteeConditionInput
  ) {
    deleteSelfRegisteredUserInvitee(input: $input, condition: $condition) {
      id
      orgID
      referredByID
      contactInformation
      shortCode
      invitationTimestamps
      createdAt
      createdBy
      updatedAt
      lastUpdatedBy
      referredBy {
        id
        email
        firstName
        lastName
        phoneNumber
        companyName
        companySize
        website
        orgID
        goals
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createAIRequest = /* GraphQL */ `
  mutation CreateAIRequest(
    $input: CreateAIRequestInput!
    $condition: ModelAIRequestConditionInput
  ) {
    createAIRequest(input: $input, condition: $condition) {
      id
      orgID
      service
      request
      response
      isError
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateAIRequest = /* GraphQL */ `
  mutation UpdateAIRequest(
    $input: UpdateAIRequestInput!
    $condition: ModelAIRequestConditionInput
  ) {
    updateAIRequest(input: $input, condition: $condition) {
      id
      orgID
      service
      request
      response
      isError
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteAIRequest = /* GraphQL */ `
  mutation DeleteAIRequest(
    $input: DeleteAIRequestInput!
    $condition: ModelAIRequestConditionInput
  ) {
    deleteAIRequest(input: $input, condition: $condition) {
      id
      orgID
      service
      request
      response
      isError
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createUserFeedback = /* GraphQL */ `
  mutation CreateUserFeedback(
    $input: CreateUserFeedbackInput!
    $condition: ModelUserFeedbackConditionInput
  ) {
    createUserFeedback(input: $input, condition: $condition) {
      id
      userID
      orgID
      wasHelpful
      sourceType
      sourceId
      reasonTag
      userFeedback
      context
      reviewedByPaiv
      reviewedAt
      reviewedBy
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateUserFeedback = /* GraphQL */ `
  mutation UpdateUserFeedback(
    $input: UpdateUserFeedbackInput!
    $condition: ModelUserFeedbackConditionInput
  ) {
    updateUserFeedback(input: $input, condition: $condition) {
      id
      userID
      orgID
      wasHelpful
      sourceType
      sourceId
      reasonTag
      userFeedback
      context
      reviewedByPaiv
      reviewedAt
      reviewedBy
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserFeedback = /* GraphQL */ `
  mutation DeleteUserFeedback(
    $input: DeleteUserFeedbackInput!
    $condition: ModelUserFeedbackConditionInput
  ) {
    deleteUserFeedback(input: $input, condition: $condition) {
      id
      userID
      orgID
      wasHelpful
      sourceType
      sourceId
      reasonTag
      userFeedback
      context
      reviewedByPaiv
      reviewedAt
      reviewedBy
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createFRRoute = /* GraphQL */ `
  mutation CreateFRRoute(
    $input: CreateFRRouteInput!
    $condition: ModelFRRouteConditionInput
  ) {
    createFRRoute(input: $input, condition: $condition) {
      id
      orgID
      routeID
      officeID
      title
      templateID
      dateAdded
      addedBy
      groupID
      groupTitle
      date
      dayNotes
      dayAlert
      dayID
      additionalTechs
      assignedTech
      assignedTechPaivID
      apiCanSchedule
      scheduleTeams
      scheduleTypes
      averageLatitude
      averageLongitude
      averageDistance
      dateUpdated
      distanceScore
      estimatedAppointmentsDurationMinutes
      estimatedDrivingDurationSeconds
      capacityEstimateValue
      lockedRoute
      totalDistance
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFRRoute = /* GraphQL */ `
  mutation UpdateFRRoute(
    $input: UpdateFRRouteInput!
    $condition: ModelFRRouteConditionInput
  ) {
    updateFRRoute(input: $input, condition: $condition) {
      id
      orgID
      routeID
      officeID
      title
      templateID
      dateAdded
      addedBy
      groupID
      groupTitle
      date
      dayNotes
      dayAlert
      dayID
      additionalTechs
      assignedTech
      assignedTechPaivID
      apiCanSchedule
      scheduleTeams
      scheduleTypes
      averageLatitude
      averageLongitude
      averageDistance
      dateUpdated
      distanceScore
      estimatedAppointmentsDurationMinutes
      estimatedDrivingDurationSeconds
      capacityEstimateValue
      lockedRoute
      totalDistance
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFRRoute = /* GraphQL */ `
  mutation DeleteFRRoute(
    $input: DeleteFRRouteInput!
    $condition: ModelFRRouteConditionInput
  ) {
    deleteFRRoute(input: $input, condition: $condition) {
      id
      orgID
      routeID
      officeID
      title
      templateID
      dateAdded
      addedBy
      groupID
      groupTitle
      date
      dayNotes
      dayAlert
      dayID
      additionalTechs
      assignedTech
      assignedTechPaivID
      apiCanSchedule
      scheduleTeams
      scheduleTypes
      averageLatitude
      averageLongitude
      averageDistance
      dateUpdated
      distanceScore
      estimatedAppointmentsDurationMinutes
      estimatedDrivingDurationSeconds
      capacityEstimateValue
      lockedRoute
      totalDistance
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFRSpot = /* GraphQL */ `
  mutation CreateFRSpot(
    $input: CreateFRSpotInput!
    $condition: ModelFRSpotConditionInput
  ) {
    createFRSpot(input: $input, condition: $condition) {
      id
      orgID
      paivRouteID
      assignedTechPaivID
      startTime
      endTime
      spotID
      officeID
      routeID
      date
      start
      end
      spotCapacity
      description
      blockReason
      currentAppointment
      assignedTech
      distanceToPrevious
      previousLat
      previousLng
      prevCustomer
      prevSpotID
      prevAppointmentID
      apiCanSchedule
      open
      lastUpdated
      dateUpdated
      distanceToNext
      nextLat
      nextLng
      nextCustomer
      nextSpotID
      nextAppointmentID
      reserved
      reservationEnd
      appointmentIDs
      customerIDs
      currentAppointmentDuration
      subscriptionID
      distanceToClosest
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFRSpot = /* GraphQL */ `
  mutation UpdateFRSpot(
    $input: UpdateFRSpotInput!
    $condition: ModelFRSpotConditionInput
  ) {
    updateFRSpot(input: $input, condition: $condition) {
      id
      orgID
      paivRouteID
      assignedTechPaivID
      startTime
      endTime
      spotID
      officeID
      routeID
      date
      start
      end
      spotCapacity
      description
      blockReason
      currentAppointment
      assignedTech
      distanceToPrevious
      previousLat
      previousLng
      prevCustomer
      prevSpotID
      prevAppointmentID
      apiCanSchedule
      open
      lastUpdated
      dateUpdated
      distanceToNext
      nextLat
      nextLng
      nextCustomer
      nextSpotID
      nextAppointmentID
      reserved
      reservationEnd
      appointmentIDs
      customerIDs
      currentAppointmentDuration
      subscriptionID
      distanceToClosest
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFRSpot = /* GraphQL */ `
  mutation DeleteFRSpot(
    $input: DeleteFRSpotInput!
    $condition: ModelFRSpotConditionInput
  ) {
    deleteFRSpot(input: $input, condition: $condition) {
      id
      orgID
      paivRouteID
      assignedTechPaivID
      startTime
      endTime
      spotID
      officeID
      routeID
      date
      start
      end
      spotCapacity
      description
      blockReason
      currentAppointment
      assignedTech
      distanceToPrevious
      previousLat
      previousLng
      prevCustomer
      prevSpotID
      prevAppointmentID
      apiCanSchedule
      open
      lastUpdated
      dateUpdated
      distanceToNext
      nextLat
      nextLng
      nextCustomer
      nextSpotID
      nextAppointmentID
      reserved
      reservationEnd
      appointmentIDs
      customerIDs
      currentAppointmentDuration
      subscriptionID
      distanceToClosest
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFieldRoutesSpot = /* GraphQL */ `
  mutation CreateFieldRoutesSpot(
    $input: CreateFieldRoutesSpotInput!
    $condition: ModelFieldRoutesSpotConditionInput
  ) {
    createFieldRoutesSpot(input: $input, condition: $condition) {
      id
      orgID
      spotID
      officeID
      routeID
      date
      start
      end
      spotCapacity
      description
      blockReason
      currentAppointment
      assignedTech
      distanceToPrevious
      previousLat
      previousLng
      prevCustomer
      prevSpotID
      prevAppointmentID
      apiCanSchedule
      open
      lastUpdated
      dateUpdated
      distanceToNext
      nextLat
      nextLng
      nextCustomer
      nextSpotID
      nextAppointmentID
      reserved
      reservationEnd
      appointmentIDs
      customerIDs
      currentAppointmentDuration
      subscriptionID
      distanceToClosest
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFieldRoutesSpot = /* GraphQL */ `
  mutation UpdateFieldRoutesSpot(
    $input: UpdateFieldRoutesSpotInput!
    $condition: ModelFieldRoutesSpotConditionInput
  ) {
    updateFieldRoutesSpot(input: $input, condition: $condition) {
      id
      orgID
      spotID
      officeID
      routeID
      date
      start
      end
      spotCapacity
      description
      blockReason
      currentAppointment
      assignedTech
      distanceToPrevious
      previousLat
      previousLng
      prevCustomer
      prevSpotID
      prevAppointmentID
      apiCanSchedule
      open
      lastUpdated
      dateUpdated
      distanceToNext
      nextLat
      nextLng
      nextCustomer
      nextSpotID
      nextAppointmentID
      reserved
      reservationEnd
      appointmentIDs
      customerIDs
      currentAppointmentDuration
      subscriptionID
      distanceToClosest
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFieldRoutesSpot = /* GraphQL */ `
  mutation DeleteFieldRoutesSpot(
    $input: DeleteFieldRoutesSpotInput!
    $condition: ModelFieldRoutesSpotConditionInput
  ) {
    deleteFieldRoutesSpot(input: $input, condition: $condition) {
      id
      orgID
      spotID
      officeID
      routeID
      date
      start
      end
      spotCapacity
      description
      blockReason
      currentAppointment
      assignedTech
      distanceToPrevious
      previousLat
      previousLng
      prevCustomer
      prevSpotID
      prevAppointmentID
      apiCanSchedule
      open
      lastUpdated
      dateUpdated
      distanceToNext
      nextLat
      nextLng
      nextCustomer
      nextSpotID
      nextAppointmentID
      reserved
      reservationEnd
      appointmentIDs
      customerIDs
      currentAppointmentDuration
      subscriptionID
      distanceToClosest
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFormTemplate = /* GraphQL */ `
  mutation CreateFormTemplate(
    $input: CreateFormTemplateInput!
    $condition: ModelFormTemplateConditionInput
  ) {
    createFormTemplate(input: $input, condition: $condition) {
      id
      orgID
      officeID
      productIDs
      name
      description
      template
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFormTemplate = /* GraphQL */ `
  mutation UpdateFormTemplate(
    $input: UpdateFormTemplateInput!
    $condition: ModelFormTemplateConditionInput
  ) {
    updateFormTemplate(input: $input, condition: $condition) {
      id
      orgID
      officeID
      productIDs
      name
      description
      template
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFormTemplate = /* GraphQL */ `
  mutation DeleteFormTemplate(
    $input: DeleteFormTemplateInput!
    $condition: ModelFormTemplateConditionInput
  ) {
    deleteFormTemplate(input: $input, condition: $condition) {
      id
      orgID
      officeID
      productIDs
      name
      description
      template
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      extID
      name
      description
      frequency
      isSubscription
      omitFromPaiv
      reservice
      officeID
      defaultCharge
      defaultLength
      defaultContractLength
      contractLengthOptions
      defaultInitialCharge
      minRecurringCharge
      minInitialCharge
      regularService
      initialService
      seasonStart
      seasonEnd
      defaultFollowupDelay
      flexAttributes
      pests
      additionalPests
      bundledProducts
      productCode
      productFamily
      listPrice
      startDate
      endDate
      units
      status
      isDeleted
      isAppVisible
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      orderLines {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      extID
      name
      description
      frequency
      isSubscription
      omitFromPaiv
      reservice
      officeID
      defaultCharge
      defaultLength
      defaultContractLength
      contractLengthOptions
      defaultInitialCharge
      minRecurringCharge
      minInitialCharge
      regularService
      initialService
      seasonStart
      seasonEnd
      defaultFollowupDelay
      flexAttributes
      pests
      additionalPests
      bundledProducts
      productCode
      productFamily
      listPrice
      startDate
      endDate
      units
      status
      isDeleted
      isAppVisible
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      orderLines {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      extID
      name
      description
      frequency
      isSubscription
      omitFromPaiv
      reservice
      officeID
      defaultCharge
      defaultLength
      defaultContractLength
      contractLengthOptions
      defaultInitialCharge
      minRecurringCharge
      minInitialCharge
      regularService
      initialService
      seasonStart
      seasonEnd
      defaultFollowupDelay
      flexAttributes
      pests
      additionalPests
      bundledProducts
      productCode
      productFamily
      listPrice
      startDate
      endDate
      units
      status
      isDeleted
      isAppVisible
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      orderLines {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      orgID
      dealID
      extID
      discountAmount
      dateSold
      isPaidInFull
      isDeleted
      orderLinesOrder
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      orderLines {
        nextToken
        __typename
      }
      payments {
        nextToken
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      id
      orgID
      dealID
      extID
      discountAmount
      dateSold
      isPaidInFull
      isDeleted
      orderLinesOrder
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      orderLines {
        nextToken
        __typename
      }
      payments {
        nextToken
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      id
      orgID
      dealID
      extID
      discountAmount
      dateSold
      isPaidInFull
      isDeleted
      orderLinesOrder
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      orderLines {
        nextToken
        __typename
      }
      payments {
        nextToken
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createOrderLine = /* GraphQL */ `
  mutation CreateOrderLine(
    $input: CreateOrderLineInput!
    $condition: ModelOrderLineConditionInput
  ) {
    createOrderLine(input: $input, condition: $condition) {
      id
      orgID
      productID
      orderID
      extID
      isSubscription
      frequencyDays
      initialDelayDays
      name
      description
      quantity
      unitPrice
      currencyCode
      discountPercent
      discountAmount
      dateSold
      status
      isInitialService
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      product {
        id
        orgID
        categoryID
        extID
        name
        description
        frequency
        isSubscription
        omitFromPaiv
        reservice
        officeID
        defaultCharge
        defaultLength
        defaultContractLength
        contractLengthOptions
        defaultInitialCharge
        minRecurringCharge
        minInitialCharge
        regularService
        initialService
        seasonStart
        seasonEnd
        defaultFollowupDelay
        flexAttributes
        pests
        additionalPests
        bundledProducts
        productCode
        productFamily
        listPrice
        startDate
        endDate
        units
        status
        isDeleted
        isAppVisible
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      order {
        id
        orgID
        dealID
        extID
        discountAmount
        dateSold
        isPaidInFull
        isDeleted
        orderLinesOrder
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateOrderLine = /* GraphQL */ `
  mutation UpdateOrderLine(
    $input: UpdateOrderLineInput!
    $condition: ModelOrderLineConditionInput
  ) {
    updateOrderLine(input: $input, condition: $condition) {
      id
      orgID
      productID
      orderID
      extID
      isSubscription
      frequencyDays
      initialDelayDays
      name
      description
      quantity
      unitPrice
      currencyCode
      discountPercent
      discountAmount
      dateSold
      status
      isInitialService
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      product {
        id
        orgID
        categoryID
        extID
        name
        description
        frequency
        isSubscription
        omitFromPaiv
        reservice
        officeID
        defaultCharge
        defaultLength
        defaultContractLength
        contractLengthOptions
        defaultInitialCharge
        minRecurringCharge
        minInitialCharge
        regularService
        initialService
        seasonStart
        seasonEnd
        defaultFollowupDelay
        flexAttributes
        pests
        additionalPests
        bundledProducts
        productCode
        productFamily
        listPrice
        startDate
        endDate
        units
        status
        isDeleted
        isAppVisible
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      order {
        id
        orgID
        dealID
        extID
        discountAmount
        dateSold
        isPaidInFull
        isDeleted
        orderLinesOrder
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteOrderLine = /* GraphQL */ `
  mutation DeleteOrderLine(
    $input: DeleteOrderLineInput!
    $condition: ModelOrderLineConditionInput
  ) {
    deleteOrderLine(input: $input, condition: $condition) {
      id
      orgID
      productID
      orderID
      extID
      isSubscription
      frequencyDays
      initialDelayDays
      name
      description
      quantity
      unitPrice
      currencyCode
      discountPercent
      discountAmount
      dateSold
      status
      isInitialService
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      product {
        id
        orgID
        categoryID
        extID
        name
        description
        frequency
        isSubscription
        omitFromPaiv
        reservice
        officeID
        defaultCharge
        defaultLength
        defaultContractLength
        contractLengthOptions
        defaultInitialCharge
        minRecurringCharge
        minInitialCharge
        regularService
        initialService
        seasonStart
        seasonEnd
        defaultFollowupDelay
        flexAttributes
        pests
        additionalPests
        bundledProducts
        productCode
        productFamily
        listPrice
        startDate
        endDate
        units
        status
        isDeleted
        isAppVisible
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      order {
        id
        orgID
        dealID
        extID
        discountAmount
        dateSold
        isPaidInFull
        isDeleted
        orderLinesOrder
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createLesson = /* GraphQL */ `
  mutation CreateLesson(
    $input: CreateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    createLesson(input: $input, condition: $condition) {
      id
      orgID
      name
      description
      isDeleted
      startDate
      endDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      details {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateLesson = /* GraphQL */ `
  mutation UpdateLesson(
    $input: UpdateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    updateLesson(input: $input, condition: $condition) {
      id
      orgID
      name
      description
      isDeleted
      startDate
      endDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      details {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteLesson = /* GraphQL */ `
  mutation DeleteLesson(
    $input: DeleteLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    deleteLesson(input: $input, condition: $condition) {
      id
      orgID
      name
      description
      isDeleted
      startDate
      endDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      details {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createLessonDetail = /* GraphQL */ `
  mutation CreateLessonDetail(
    $input: CreateLessonDetailInput!
    $condition: ModelLessonDetailConditionInput
  ) {
    createLessonDetail(input: $input, condition: $condition) {
      id
      lessonID
      orgID
      name
      description
      category
      order
      imageType
      imageName
      posterImageName
      url
      urlType
      youTubeURL
      flexFields
      startDate
      endDate
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      lesson {
        id
        orgID
        name
        description
        isDeleted
        startDate
        endDate
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      assignments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateLessonDetail = /* GraphQL */ `
  mutation UpdateLessonDetail(
    $input: UpdateLessonDetailInput!
    $condition: ModelLessonDetailConditionInput
  ) {
    updateLessonDetail(input: $input, condition: $condition) {
      id
      lessonID
      orgID
      name
      description
      category
      order
      imageType
      imageName
      posterImageName
      url
      urlType
      youTubeURL
      flexFields
      startDate
      endDate
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      lesson {
        id
        orgID
        name
        description
        isDeleted
        startDate
        endDate
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      assignments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteLessonDetail = /* GraphQL */ `
  mutation DeleteLessonDetail(
    $input: DeleteLessonDetailInput!
    $condition: ModelLessonDetailConditionInput
  ) {
    deleteLessonDetail(input: $input, condition: $condition) {
      id
      lessonID
      orgID
      name
      description
      category
      order
      imageType
      imageName
      posterImageName
      url
      urlType
      youTubeURL
      flexFields
      startDate
      endDate
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      lesson {
        id
        orgID
        name
        description
        isDeleted
        startDate
        endDate
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      assignments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createLessonAssignment = /* GraphQL */ `
  mutation CreateLessonAssignment(
    $input: CreateLessonAssignmentInput!
    $condition: ModelLessonAssignmentConditionInput
  ) {
    createLessonAssignment(input: $input, condition: $condition) {
      id
      lessonDetailID
      orgID
      assignedToID
      assignedToType
      flexAttributes
      startedTmst
      completedTmst
      percentComplete
      isStarted
      isComplete
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      lessonDetail {
        id
        lessonID
        orgID
        name
        description
        category
        order
        imageType
        imageName
        posterImageName
        url
        urlType
        youTubeURL
        flexFields
        startDate
        endDate
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateLessonAssignment = /* GraphQL */ `
  mutation UpdateLessonAssignment(
    $input: UpdateLessonAssignmentInput!
    $condition: ModelLessonAssignmentConditionInput
  ) {
    updateLessonAssignment(input: $input, condition: $condition) {
      id
      lessonDetailID
      orgID
      assignedToID
      assignedToType
      flexAttributes
      startedTmst
      completedTmst
      percentComplete
      isStarted
      isComplete
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      lessonDetail {
        id
        lessonID
        orgID
        name
        description
        category
        order
        imageType
        imageName
        posterImageName
        url
        urlType
        youTubeURL
        flexFields
        startDate
        endDate
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteLessonAssignment = /* GraphQL */ `
  mutation DeleteLessonAssignment(
    $input: DeleteLessonAssignmentInput!
    $condition: ModelLessonAssignmentConditionInput
  ) {
    deleteLessonAssignment(input: $input, condition: $condition) {
      id
      lessonDetailID
      orgID
      assignedToID
      assignedToType
      flexAttributes
      startedTmst
      completedTmst
      percentComplete
      isStarted
      isComplete
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      lessonDetail {
        id
        lessonID
        orgID
        name
        description
        category
        order
        imageType
        imageName
        posterImageName
        url
        urlType
        youTubeURL
        flexFields
        startDate
        endDate
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createDealPaymentTokens = /* GraphQL */ `
  mutation CreateDealPaymentTokens(
    $input: CreateDealPaymentTokensInput!
    $condition: ModeldealPaymentTokensConditionInput
  ) {
    createDealPaymentTokens(input: $input, condition: $condition) {
      id
      orgID
      dealID
      isDeleted
      type
      address_zip
      brand
      exp_month
      exp_year
      transaction_id
      last_4
      name
      routing_number
      token
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDealPaymentTokens = /* GraphQL */ `
  mutation UpdateDealPaymentTokens(
    $input: UpdateDealPaymentTokensInput!
    $condition: ModeldealPaymentTokensConditionInput
  ) {
    updateDealPaymentTokens(input: $input, condition: $condition) {
      id
      orgID
      dealID
      isDeleted
      type
      address_zip
      brand
      exp_month
      exp_year
      transaction_id
      last_4
      name
      routing_number
      token
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDealPaymentTokens = /* GraphQL */ `
  mutation DeleteDealPaymentTokens(
    $input: DeleteDealPaymentTokensInput!
    $condition: ModeldealPaymentTokensConditionInput
  ) {
    deleteDealPaymentTokens(input: $input, condition: $condition) {
      id
      orgID
      dealID
      isDeleted
      type
      address_zip
      brand
      exp_month
      exp_year
      transaction_id
      last_4
      name
      routing_number
      token
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDealPayment = /* GraphQL */ `
  mutation CreateDealPayment(
    $input: CreateDealPaymentInput!
    $condition: ModeldealPaymentConditionInput
  ) {
    createDealPayment(input: $input, condition: $condition) {
      id
      orgID
      dealID
      orderID
      type
      transactionAmount
      transactionID
      cardToken
      description
      currencyCode
      responseJSON
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDealPayment = /* GraphQL */ `
  mutation UpdateDealPayment(
    $input: UpdateDealPaymentInput!
    $condition: ModeldealPaymentConditionInput
  ) {
    updateDealPayment(input: $input, condition: $condition) {
      id
      orgID
      dealID
      orderID
      type
      transactionAmount
      transactionID
      cardToken
      description
      currencyCode
      responseJSON
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDealPayment = /* GraphQL */ `
  mutation DeleteDealPayment(
    $input: DeleteDealPaymentInput!
    $condition: ModeldealPaymentConditionInput
  ) {
    deleteDealPayment(input: $input, condition: $condition) {
      id
      orgID
      dealID
      orderID
      type
      transactionAmount
      transactionID
      cardToken
      description
      currencyCode
      responseJSON
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCreditCardAuths = /* GraphQL */ `
  mutation CreateCreditCardAuths(
    $input: CreateCreditCardAuthsInput!
    $condition: ModelcreditCardAuthsConditionInput
  ) {
    createCreditCardAuths(input: $input, condition: $condition) {
      id
      orgID
      amount
      amountCharged
      feePercent
      referenceDepositID
      status
      creditCardToken
      userID
      creditCardLabel
      lastFourDigits
      expirationDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCreditCardAuths = /* GraphQL */ `
  mutation UpdateCreditCardAuths(
    $input: UpdateCreditCardAuthsInput!
    $condition: ModelcreditCardAuthsConditionInput
  ) {
    updateCreditCardAuths(input: $input, condition: $condition) {
      id
      orgID
      amount
      amountCharged
      feePercent
      referenceDepositID
      status
      creditCardToken
      userID
      creditCardLabel
      lastFourDigits
      expirationDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCreditCardAuths = /* GraphQL */ `
  mutation DeleteCreditCardAuths(
    $input: DeleteCreditCardAuthsInput!
    $condition: ModelcreditCardAuthsConditionInput
  ) {
    deleteCreditCardAuths(input: $input, condition: $condition) {
      id
      orgID
      amount
      amountCharged
      feePercent
      referenceDepositID
      status
      creditCardToken
      userID
      creditCardLabel
      lastFourDigits
      expirationDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createExportedData = /* GraphQL */ `
  mutation CreateExportedData(
    $input: CreateExportedDataInput!
    $condition: ModelExportedDataConditionInput
  ) {
    createExportedData(input: $input, condition: $condition) {
      id
      orgID
      exportDataID
      lastExportTmst
      exportableData {
        id
        name
        description
        allowStartDate
        allowEndDate
        allowAll
        allowChangeEmail
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateExportedData = /* GraphQL */ `
  mutation UpdateExportedData(
    $input: UpdateExportedDataInput!
    $condition: ModelExportedDataConditionInput
  ) {
    updateExportedData(input: $input, condition: $condition) {
      id
      orgID
      exportDataID
      lastExportTmst
      exportableData {
        id
        name
        description
        allowStartDate
        allowEndDate
        allowAll
        allowChangeEmail
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteExportedData = /* GraphQL */ `
  mutation DeleteExportedData(
    $input: DeleteExportedDataInput!
    $condition: ModelExportedDataConditionInput
  ) {
    deleteExportedData(input: $input, condition: $condition) {
      id
      orgID
      exportDataID
      lastExportTmst
      exportableData {
        id
        name
        description
        allowStartDate
        allowEndDate
        allowAll
        allowChangeEmail
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createExportedDataHistory = /* GraphQL */ `
  mutation CreateExportedDataHistory(
    $input: CreateExportedDataHistoryInput!
    $condition: ModelExportedDataHistoryConditionInput
  ) {
    createExportedDataHistory(input: $input, condition: $condition) {
      id
      orgID
      exportDataID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateExportedDataHistory = /* GraphQL */ `
  mutation UpdateExportedDataHistory(
    $input: UpdateExportedDataHistoryInput!
    $condition: ModelExportedDataHistoryConditionInput
  ) {
    updateExportedDataHistory(input: $input, condition: $condition) {
      id
      orgID
      exportDataID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteExportedDataHistory = /* GraphQL */ `
  mutation DeleteExportedDataHistory(
    $input: DeleteExportedDataHistoryInput!
    $condition: ModelExportedDataHistoryConditionInput
  ) {
    deleteExportedDataHistory(input: $input, condition: $condition) {
      id
      orgID
      exportDataID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPersonDefaultSchedule = /* GraphQL */ `
  mutation CreatePersonDefaultSchedule(
    $input: CreatePersonDefaultScheduleInput!
    $condition: ModelPersonDefaultScheduleConditionInput
  ) {
    createPersonDefaultSchedule(input: $input, condition: $condition) {
      id
      orgID
      userID
      circleIDs
      officeID
      days
      startDate
      endDate
      startTime
      endTime
      minimumMeetingLength
      maximumMeetingLength
      defaultMeetingLength
      minutesBetweenMeetings
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePersonDefaultSchedule = /* GraphQL */ `
  mutation UpdatePersonDefaultSchedule(
    $input: UpdatePersonDefaultScheduleInput!
    $condition: ModelPersonDefaultScheduleConditionInput
  ) {
    updatePersonDefaultSchedule(input: $input, condition: $condition) {
      id
      orgID
      userID
      circleIDs
      officeID
      days
      startDate
      endDate
      startTime
      endTime
      minimumMeetingLength
      maximumMeetingLength
      defaultMeetingLength
      minutesBetweenMeetings
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePersonDefaultSchedule = /* GraphQL */ `
  mutation DeletePersonDefaultSchedule(
    $input: DeletePersonDefaultScheduleInput!
    $condition: ModelPersonDefaultScheduleConditionInput
  ) {
    deletePersonDefaultSchedule(input: $input, condition: $condition) {
      id
      orgID
      userID
      circleIDs
      officeID
      days
      startDate
      endDate
      startTime
      endTime
      minimumMeetingLength
      maximumMeetingLength
      defaultMeetingLength
      minutesBetweenMeetings
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPersonScheduleOverride = /* GraphQL */ `
  mutation CreatePersonScheduleOverride(
    $input: CreatePersonScheduleOverrideInput!
    $condition: ModelPersonScheduleOverrideConditionInput
  ) {
    createPersonScheduleOverride(input: $input, condition: $condition) {
      id
      orgID
      userID
      date
      startTime
      endTime
      minimumMeetingLength
      maximumMeetingLength
      defaultMeetingLength
      minutesBetweenMeetings
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePersonScheduleOverride = /* GraphQL */ `
  mutation UpdatePersonScheduleOverride(
    $input: UpdatePersonScheduleOverrideInput!
    $condition: ModelPersonScheduleOverrideConditionInput
  ) {
    updatePersonScheduleOverride(input: $input, condition: $condition) {
      id
      orgID
      userID
      date
      startTime
      endTime
      minimumMeetingLength
      maximumMeetingLength
      defaultMeetingLength
      minutesBetweenMeetings
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePersonScheduleOverride = /* GraphQL */ `
  mutation DeletePersonScheduleOverride(
    $input: DeletePersonScheduleOverrideInput!
    $condition: ModelPersonScheduleOverrideConditionInput
  ) {
    deletePersonScheduleOverride(input: $input, condition: $condition) {
      id
      orgID
      userID
      date
      startTime
      endTime
      minimumMeetingLength
      maximumMeetingLength
      defaultMeetingLength
      minutesBetweenMeetings
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSpot = /* GraphQL */ `
  mutation CreateSpot(
    $input: CreateSpotInput!
    $condition: ModelSpotConditionInput
  ) {
    createSpot(input: $input, condition: $condition) {
      id
      orgID
      userID
      officeID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateSpot = /* GraphQL */ `
  mutation UpdateSpot(
    $input: UpdateSpotInput!
    $condition: ModelSpotConditionInput
  ) {
    updateSpot(input: $input, condition: $condition) {
      id
      orgID
      userID
      officeID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteSpot = /* GraphQL */ `
  mutation DeleteSpot(
    $input: DeleteSpotInput!
    $condition: ModelSpotConditionInput
  ) {
    deleteSpot(input: $input, condition: $condition) {
      id
      orgID
      userID
      officeID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createPersonAppointment = /* GraphQL */ `
  mutation CreatePersonAppointment(
    $input: CreatePersonAppointmentInput!
    $condition: ModelPersonAppointmentConditionInput
  ) {
    createPersonAppointment(input: $input, condition: $condition) {
      id
      orgID
      userID
      setterID
      extID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      notes
      status
      statusSetterRole
      dealID
      officeID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      history {
        nextToken
        __typename
      }
      address {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      setter {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updatePersonAppointment = /* GraphQL */ `
  mutation UpdatePersonAppointment(
    $input: UpdatePersonAppointmentInput!
    $condition: ModelPersonAppointmentConditionInput
  ) {
    updatePersonAppointment(input: $input, condition: $condition) {
      id
      orgID
      userID
      setterID
      extID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      notes
      status
      statusSetterRole
      dealID
      officeID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      history {
        nextToken
        __typename
      }
      address {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      setter {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deletePersonAppointment = /* GraphQL */ `
  mutation DeletePersonAppointment(
    $input: DeletePersonAppointmentInput!
    $condition: ModelPersonAppointmentConditionInput
  ) {
    deletePersonAppointment(input: $input, condition: $condition) {
      id
      orgID
      userID
      setterID
      extID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      notes
      status
      statusSetterRole
      dealID
      officeID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      history {
        nextToken
        __typename
      }
      address {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      setter {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createPersonAppointmentHistory = /* GraphQL */ `
  mutation CreatePersonAppointmentHistory(
    $input: CreatePersonAppointmentHistoryInput!
    $condition: ModelPersonAppointmentHistoryConditionInput
  ) {
    createPersonAppointmentHistory(input: $input, condition: $condition) {
      id
      personAppointmentID
      orgID
      userID
      setterID
      changerID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      notes
      status
      statusSetterRole
      dealID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      setter {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      changeUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updatePersonAppointmentHistory = /* GraphQL */ `
  mutation UpdatePersonAppointmentHistory(
    $input: UpdatePersonAppointmentHistoryInput!
    $condition: ModelPersonAppointmentHistoryConditionInput
  ) {
    updatePersonAppointmentHistory(input: $input, condition: $condition) {
      id
      personAppointmentID
      orgID
      userID
      setterID
      changerID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      notes
      status
      statusSetterRole
      dealID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      setter {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      changeUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deletePersonAppointmentHistory = /* GraphQL */ `
  mutation DeletePersonAppointmentHistory(
    $input: DeletePersonAppointmentHistoryInput!
    $condition: ModelPersonAppointmentHistoryConditionInput
  ) {
    deletePersonAppointmentHistory(input: $input, condition: $condition) {
      id
      personAppointmentID
      orgID
      userID
      setterID
      changerID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      notes
      status
      statusSetterRole
      dealID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      setter {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      changeUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createServiceArea = /* GraphQL */ `
  mutation CreateServiceArea(
    $input: CreateServiceAreaInput!
    $condition: ModelServiceAreaConditionInput
  ) {
    createServiceArea(input: $input, condition: $condition) {
      id
      orgID
      name
      description
      coords {
        lat
        lon
        __typename
      }
      zipCodes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      calendars {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateServiceArea = /* GraphQL */ `
  mutation UpdateServiceArea(
    $input: UpdateServiceAreaInput!
    $condition: ModelServiceAreaConditionInput
  ) {
    updateServiceArea(input: $input, condition: $condition) {
      id
      orgID
      name
      description
      coords {
        lat
        lon
        __typename
      }
      zipCodes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      calendars {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteServiceArea = /* GraphQL */ `
  mutation DeleteServiceArea(
    $input: DeleteServiceAreaInput!
    $condition: ModelServiceAreaConditionInput
  ) {
    deleteServiceArea(input: $input, condition: $condition) {
      id
      orgID
      name
      description
      coords {
        lat
        lon
        __typename
      }
      zipCodes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      calendars {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createCalendar = /* GraphQL */ `
  mutation CreateCalendar(
    $input: CreateCalendarInput!
    $condition: ModelCalendarConditionInput
  ) {
    createCalendar(input: $input, condition: $condition) {
      id
      orgID
      scheduleDate
      areaID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      area {
        id
        orgID
        name
        description
        zipCodes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      slots {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateCalendar = /* GraphQL */ `
  mutation UpdateCalendar(
    $input: UpdateCalendarInput!
    $condition: ModelCalendarConditionInput
  ) {
    updateCalendar(input: $input, condition: $condition) {
      id
      orgID
      scheduleDate
      areaID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      area {
        id
        orgID
        name
        description
        zipCodes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      slots {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteCalendar = /* GraphQL */ `
  mutation DeleteCalendar(
    $input: DeleteCalendarInput!
    $condition: ModelCalendarConditionInput
  ) {
    deleteCalendar(input: $input, condition: $condition) {
      id
      orgID
      scheduleDate
      areaID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      area {
        id
        orgID
        name
        description
        zipCodes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      slots {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createCalendarSlot = /* GraphQL */ `
  mutation CreateCalendarSlot(
    $input: CreateCalendarSlotInput!
    $condition: ModelCalendarSlotConditionInput
  ) {
    createCalendarSlot(input: $input, condition: $condition) {
      id
      orgID
      calendarID
      startTime
      endTime
      available
      scheduled
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      appointments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateCalendarSlot = /* GraphQL */ `
  mutation UpdateCalendarSlot(
    $input: UpdateCalendarSlotInput!
    $condition: ModelCalendarSlotConditionInput
  ) {
    updateCalendarSlot(input: $input, condition: $condition) {
      id
      orgID
      calendarID
      startTime
      endTime
      available
      scheduled
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      appointments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteCalendarSlot = /* GraphQL */ `
  mutation DeleteCalendarSlot(
    $input: DeleteCalendarSlotInput!
    $condition: ModelCalendarSlotConditionInput
  ) {
    deleteCalendarSlot(input: $input, condition: $condition) {
      id
      orgID
      calendarID
      startTime
      endTime
      available
      scheduled
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      appointments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createCalendarAppointment = /* GraphQL */ `
  mutation CreateCalendarAppointment(
    $input: CreateCalendarAppointmentInput!
    $condition: ModelCalendarAppointmentConditionInput
  ) {
    createCalendarAppointment(input: $input, condition: $condition) {
      id
      orgID
      slotID
      dealID
      notes
      status
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      slot {
        id
        orgID
        calendarID
        startTime
        endTime
        available
        scheduled
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateCalendarAppointment = /* GraphQL */ `
  mutation UpdateCalendarAppointment(
    $input: UpdateCalendarAppointmentInput!
    $condition: ModelCalendarAppointmentConditionInput
  ) {
    updateCalendarAppointment(input: $input, condition: $condition) {
      id
      orgID
      slotID
      dealID
      notes
      status
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      slot {
        id
        orgID
        calendarID
        startTime
        endTime
        available
        scheduled
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteCalendarAppointment = /* GraphQL */ `
  mutation DeleteCalendarAppointment(
    $input: DeleteCalendarAppointmentInput!
    $condition: ModelCalendarAppointmentConditionInput
  ) {
    deleteCalendarAppointment(input: $input, condition: $condition) {
      id
      orgID
      slotID
      dealID
      notes
      status
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      slot {
        id
        orgID
        calendarID
        startTime
        endTime
        available
        scheduled
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createUserAddress = /* GraphQL */ `
  mutation CreateUserAddress(
    $input: CreateUserAddressInput!
    $condition: ModelUserAddressConditionInput
  ) {
    createUserAddress(input: $input, condition: $condition) {
      id
      userID
      orgID
      type
      address1
      address2
      city
      region
      country
      postalCode
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateUserAddress = /* GraphQL */ `
  mutation UpdateUserAddress(
    $input: UpdateUserAddressInput!
    $condition: ModelUserAddressConditionInput
  ) {
    updateUserAddress(input: $input, condition: $condition) {
      id
      userID
      orgID
      type
      address1
      address2
      city
      region
      country
      postalCode
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserAddress = /* GraphQL */ `
  mutation DeleteUserAddress(
    $input: DeleteUserAddressInput!
    $condition: ModelUserAddressConditionInput
  ) {
    deleteUserAddress(input: $input, condition: $condition) {
      id
      userID
      orgID
      type
      address1
      address2
      city
      region
      country
      postalCode
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createPindropLog = /* GraphQL */ `
  mutation CreatePindropLog(
    $input: CreatePindropLogInput!
    $condition: ModelPindropLogConditionInput
  ) {
    createPindropLog(input: $input, condition: $condition) {
      id
      orgID
      addressID
      createdBy
      createdAt
      dispositionID
      isDeleted
      appVersionCode
      deviceType
      officeID
      updatedAt
      __typename
    }
  }
`;
export const updatePindropLog = /* GraphQL */ `
  mutation UpdatePindropLog(
    $input: UpdatePindropLogInput!
    $condition: ModelPindropLogConditionInput
  ) {
    updatePindropLog(input: $input, condition: $condition) {
      id
      orgID
      addressID
      createdBy
      createdAt
      dispositionID
      isDeleted
      appVersionCode
      deviceType
      officeID
      updatedAt
      __typename
    }
  }
`;
export const deletePindropLog = /* GraphQL */ `
  mutation DeletePindropLog(
    $input: DeletePindropLogInput!
    $condition: ModelPindropLogConditionInput
  ) {
    deletePindropLog(input: $input, condition: $condition) {
      id
      orgID
      addressID
      createdBy
      createdAt
      dispositionID
      isDeleted
      appVersionCode
      deviceType
      officeID
      updatedAt
      __typename
    }
  }
`;
export const createAddress = /* GraphQL */ `
  mutation CreateAddress(
    $input: CreateAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    createAddress(input: $input, condition: $condition) {
      id
      customerID
      doorDataID
      categoryID
      orgID
      isMultiUnit
      parentAddressID
      street
      address
      unitNumber
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      distanceFromDoor
      lastVisited
      nextVisit
      currentOwnerID
      lastVisitedByID
      lastVisitedByName
      currentDispositionID
      status
      officeID
      flexAttributes
      name
      creditEstimate
      maritalStatus
      renterFlag
      age
      income
      lengthOfResidence
      expireAt
      expireAtEpoch
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      isHidden
      tags {
        nextToken
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateAddress = /* GraphQL */ `
  mutation UpdateAddress(
    $input: UpdateAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    updateAddress(input: $input, condition: $condition) {
      id
      customerID
      doorDataID
      categoryID
      orgID
      isMultiUnit
      parentAddressID
      street
      address
      unitNumber
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      distanceFromDoor
      lastVisited
      nextVisit
      currentOwnerID
      lastVisitedByID
      lastVisitedByName
      currentDispositionID
      status
      officeID
      flexAttributes
      name
      creditEstimate
      maritalStatus
      renterFlag
      age
      income
      lengthOfResidence
      expireAt
      expireAtEpoch
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      isHidden
      tags {
        nextToken
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteAddress = /* GraphQL */ `
  mutation DeleteAddress(
    $input: DeleteAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    deleteAddress(input: $input, condition: $condition) {
      id
      customerID
      doorDataID
      categoryID
      orgID
      isMultiUnit
      parentAddressID
      street
      address
      unitNumber
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      distanceFromDoor
      lastVisited
      nextVisit
      currentOwnerID
      lastVisitedByID
      lastVisitedByName
      currentDispositionID
      status
      officeID
      flexAttributes
      name
      creditEstimate
      maritalStatus
      renterFlag
      age
      income
      lengthOfResidence
      expireAt
      expireAtEpoch
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      isHidden
      tags {
        nextToken
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createInaccurateAddressCoordinates = /* GraphQL */ `
  mutation CreateInaccurateAddressCoordinates(
    $input: CreateInaccurateAddressCoordinatesInput!
    $condition: ModelInaccurateAddressCoordinatesConditionInput
  ) {
    createInaccurateAddressCoordinates(input: $input, condition: $condition) {
      id
      orgID
      createdAt
      updatedAt
      address
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      geoCodeMatchLevel
      doorDataID
      distanceFromDoor
      actualPinCoordinates {
        lat
        lon
        __typename
      }
      lastUpdatedBy
      doorCreatedAt
      doorUpdatedAt
      __typename
    }
  }
`;
export const updateInaccurateAddressCoordinates = /* GraphQL */ `
  mutation UpdateInaccurateAddressCoordinates(
    $input: UpdateInaccurateAddressCoordinatesInput!
    $condition: ModelInaccurateAddressCoordinatesConditionInput
  ) {
    updateInaccurateAddressCoordinates(input: $input, condition: $condition) {
      id
      orgID
      createdAt
      updatedAt
      address
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      geoCodeMatchLevel
      doorDataID
      distanceFromDoor
      actualPinCoordinates {
        lat
        lon
        __typename
      }
      lastUpdatedBy
      doorCreatedAt
      doorUpdatedAt
      __typename
    }
  }
`;
export const deleteInaccurateAddressCoordinates = /* GraphQL */ `
  mutation DeleteInaccurateAddressCoordinates(
    $input: DeleteInaccurateAddressCoordinatesInput!
    $condition: ModelInaccurateAddressCoordinatesConditionInput
  ) {
    deleteInaccurateAddressCoordinates(input: $input, condition: $condition) {
      id
      orgID
      createdAt
      updatedAt
      address
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      geoCodeMatchLevel
      doorDataID
      distanceFromDoor
      actualPinCoordinates {
        lat
        lon
        __typename
      }
      lastUpdatedBy
      doorCreatedAt
      doorUpdatedAt
      __typename
    }
  }
`;
export const createRoute = /* GraphQL */ `
  mutation CreateRoute(
    $input: CreateRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    createRoute(input: $input, condition: $condition) {
      id
      orgID
      routeDate
      name
      description
      lastVisited
      scheduledDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateRoute = /* GraphQL */ `
  mutation UpdateRoute(
    $input: UpdateRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    updateRoute(input: $input, condition: $condition) {
      id
      orgID
      routeDate
      name
      description
      lastVisited
      scheduledDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteRoute = /* GraphQL */ `
  mutation DeleteRoute(
    $input: DeleteRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    deleteRoute(input: $input, condition: $condition) {
      id
      orgID
      routeDate
      name
      description
      lastVisited
      scheduledDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createRouteAssignee = /* GraphQL */ `
  mutation CreateRouteAssignee(
    $input: CreateRouteAssigneeInput!
    $condition: ModelRouteAssigneeConditionInput
  ) {
    createRouteAssignee(input: $input, condition: $condition) {
      id
      orgID
      routeID
      assigneeID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateRouteAssignee = /* GraphQL */ `
  mutation UpdateRouteAssignee(
    $input: UpdateRouteAssigneeInput!
    $condition: ModelRouteAssigneeConditionInput
  ) {
    updateRouteAssignee(input: $input, condition: $condition) {
      id
      orgID
      routeID
      assigneeID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteRouteAssignee = /* GraphQL */ `
  mutation DeleteRouteAssignee(
    $input: DeleteRouteAssigneeInput!
    $condition: ModelRouteAssigneeConditionInput
  ) {
    deleteRouteAssignee(input: $input, condition: $condition) {
      id
      orgID
      routeID
      assigneeID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createRouteStop = /* GraphQL */ `
  mutation CreateRouteStop(
    $input: CreateRouteStopInput!
    $condition: ModelRouteStopConditionInput
  ) {
    createRouteStop(input: $input, condition: $condition) {
      id
      orgID
      routeID
      addressID
      appointmentID
      name
      street
      address
      unitNumber
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      appointment {
        id
        orgID
        userID
        setterID
        extID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        notes
        status
        statusSetterRole
        dealID
        officeID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      stopAddress {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      __typename
    }
  }
`;
export const updateRouteStop = /* GraphQL */ `
  mutation UpdateRouteStop(
    $input: UpdateRouteStopInput!
    $condition: ModelRouteStopConditionInput
  ) {
    updateRouteStop(input: $input, condition: $condition) {
      id
      orgID
      routeID
      addressID
      appointmentID
      name
      street
      address
      unitNumber
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      appointment {
        id
        orgID
        userID
        setterID
        extID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        notes
        status
        statusSetterRole
        dealID
        officeID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      stopAddress {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      __typename
    }
  }
`;
export const deleteRouteStop = /* GraphQL */ `
  mutation DeleteRouteStop(
    $input: DeleteRouteStopInput!
    $condition: ModelRouteStopConditionInput
  ) {
    deleteRouteStop(input: $input, condition: $condition) {
      id
      orgID
      routeID
      addressID
      appointmentID
      name
      street
      address
      unitNumber
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      appointment {
        id
        orgID
        userID
        setterID
        extID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        notes
        status
        statusSetterRole
        dealID
        officeID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      stopAddress {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      __typename
    }
  }
`;
export const createGeoFence = /* GraphQL */ `
  mutation CreateGeoFence(
    $input: CreateGeoFenceInput!
    $condition: ModelgeoFenceConditionInput
  ) {
    createGeoFence(input: $input, condition: $condition) {
      id
      orgID
      points {
        lat
        lon
        __typename
      }
      assigneeID
      assigneeIDs
      assigneeType
      currentUserID
      status
      name
      description
      possibleAddresses
      knockedAddresses
      tags
      colorCode
      flexAttributes
      lastVisited
      scheduledDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      assignees {
        nextToken
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      currentUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateGeoFence = /* GraphQL */ `
  mutation UpdateGeoFence(
    $input: UpdateGeoFenceInput!
    $condition: ModelgeoFenceConditionInput
  ) {
    updateGeoFence(input: $input, condition: $condition) {
      id
      orgID
      points {
        lat
        lon
        __typename
      }
      assigneeID
      assigneeIDs
      assigneeType
      currentUserID
      status
      name
      description
      possibleAddresses
      knockedAddresses
      tags
      colorCode
      flexAttributes
      lastVisited
      scheduledDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      assignees {
        nextToken
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      currentUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteGeoFence = /* GraphQL */ `
  mutation DeleteGeoFence(
    $input: DeleteGeoFenceInput!
    $condition: ModelgeoFenceConditionInput
  ) {
    deleteGeoFence(input: $input, condition: $condition) {
      id
      orgID
      points {
        lat
        lon
        __typename
      }
      assigneeID
      assigneeIDs
      assigneeType
      currentUserID
      status
      name
      description
      possibleAddresses
      knockedAddresses
      tags
      colorCode
      flexAttributes
      lastVisited
      scheduledDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      assignees {
        nextToken
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      currentUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createGeoFenceAssignee = /* GraphQL */ `
  mutation CreateGeoFenceAssignee(
    $input: CreateGeoFenceAssigneeInput!
    $condition: ModelGeoFenceAssigneeConditionInput
  ) {
    createGeoFenceAssignee(input: $input, condition: $condition) {
      id
      orgID
      geofenceID
      assigneeID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateGeoFenceAssignee = /* GraphQL */ `
  mutation UpdateGeoFenceAssignee(
    $input: UpdateGeoFenceAssigneeInput!
    $condition: ModelGeoFenceAssigneeConditionInput
  ) {
    updateGeoFenceAssignee(input: $input, condition: $condition) {
      id
      orgID
      geofenceID
      assigneeID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteGeoFenceAssignee = /* GraphQL */ `
  mutation DeleteGeoFenceAssignee(
    $input: DeleteGeoFenceAssigneeInput!
    $condition: ModelGeoFenceAssigneeConditionInput
  ) {
    deleteGeoFenceAssignee(input: $input, condition: $condition) {
      id
      orgID
      geofenceID
      assigneeID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      addressID
      extID
      parentCustomerID
      firstName
      lastName
      phone {
        phoneType
        number
        __typename
      }
      email
      address1
      address2
      city
      region
      postalCode
      country
      location {
        lat
        lon
        __typename
      }
      customerType
      leadSource
      flexAttributes
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      addressID
      extID
      parentCustomerID
      firstName
      lastName
      phone {
        phoneType
        number
        __typename
      }
      email
      address1
      address2
      city
      region
      postalCode
      country
      location {
        lat
        lon
        __typename
      }
      customerType
      leadSource
      flexAttributes
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      addressID
      extID
      parentCustomerID
      firstName
      lastName
      phone {
        phoneType
        number
        __typename
      }
      email
      address1
      address2
      city
      region
      postalCode
      country
      location {
        lat
        lon
        __typename
      }
      customerType
      leadSource
      flexAttributes
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createTag = /* GraphQL */ `
  mutation CreateTag(
    $input: CreateTagInput!
    $condition: ModelTagConditionInput
  ) {
    createTag(input: $input, condition: $condition) {
      id
      orgID
      name
      color
      icon
      isGlobal
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateTag = /* GraphQL */ `
  mutation UpdateTag(
    $input: UpdateTagInput!
    $condition: ModelTagConditionInput
  ) {
    updateTag(input: $input, condition: $condition) {
      id
      orgID
      name
      color
      icon
      isGlobal
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteTag = /* GraphQL */ `
  mutation DeleteTag(
    $input: DeleteTagInput!
    $condition: ModelTagConditionInput
  ) {
    deleteTag(input: $input, condition: $condition) {
      id
      orgID
      name
      color
      icon
      isGlobal
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createTagAssignment = /* GraphQL */ `
  mutation CreateTagAssignment(
    $input: CreateTagAssignmentInput!
    $condition: ModelTagAssignmentConditionInput
  ) {
    createTagAssignment(input: $input, condition: $condition) {
      id
      orgID
      taggedObjectID
      tagID
      taggedObjectType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      tag {
        id
        orgID
        name
        color
        icon
        isGlobal
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateTagAssignment = /* GraphQL */ `
  mutation UpdateTagAssignment(
    $input: UpdateTagAssignmentInput!
    $condition: ModelTagAssignmentConditionInput
  ) {
    updateTagAssignment(input: $input, condition: $condition) {
      id
      orgID
      taggedObjectID
      tagID
      taggedObjectType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      tag {
        id
        orgID
        name
        color
        icon
        isGlobal
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteTagAssignment = /* GraphQL */ `
  mutation DeleteTagAssignment(
    $input: DeleteTagAssignmentInput!
    $condition: ModelTagAssignmentConditionInput
  ) {
    deleteTagAssignment(input: $input, condition: $condition) {
      id
      orgID
      taggedObjectID
      tagID
      taggedObjectType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      tag {
        id
        orgID
        name
        color
        icon
        isGlobal
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createDeal = /* GraphQL */ `
  mutation CreateDeal(
    $input: CreateDealInput!
    $condition: ModelDealConditionInput
  ) {
    createDeal(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      isContract
      customerID
      dealTypeID
      extID
      name
      sortName
      description
      searchString
      ownersString
      officeID
      value
      notes
      status
      currentStageID
      currentOwnerID
      defaultCircleID
      currentOwnerType
      currentDispositionID
      nextFollowupDate
      reminderSentTmst
      flexAttributes
      previousFlexAttributes
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      paymentTokens {
        nextToken
        __typename
      }
      DealAppointments {
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      pinAddress {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      tags {
        nextToken
        __typename
      }
      transactions {
        nextToken
        __typename
      }
      ownerHistory {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      files {
        nextToken
        __typename
      }
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        requireCloser
        sendToCRM
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      actions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateDeal = /* GraphQL */ `
  mutation UpdateDeal(
    $input: UpdateDealInput!
    $condition: ModelDealConditionInput
  ) {
    updateDeal(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      isContract
      customerID
      dealTypeID
      extID
      name
      sortName
      description
      searchString
      ownersString
      officeID
      value
      notes
      status
      currentStageID
      currentOwnerID
      defaultCircleID
      currentOwnerType
      currentDispositionID
      nextFollowupDate
      reminderSentTmst
      flexAttributes
      previousFlexAttributes
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      paymentTokens {
        nextToken
        __typename
      }
      DealAppointments {
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      pinAddress {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      tags {
        nextToken
        __typename
      }
      transactions {
        nextToken
        __typename
      }
      ownerHistory {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      files {
        nextToken
        __typename
      }
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        requireCloser
        sendToCRM
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      actions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteDeal = /* GraphQL */ `
  mutation DeleteDeal(
    $input: DeleteDealInput!
    $condition: ModelDealConditionInput
  ) {
    deleteDeal(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      isContract
      customerID
      dealTypeID
      extID
      name
      sortName
      description
      searchString
      ownersString
      officeID
      value
      notes
      status
      currentStageID
      currentOwnerID
      defaultCircleID
      currentOwnerType
      currentDispositionID
      nextFollowupDate
      reminderSentTmst
      flexAttributes
      previousFlexAttributes
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      paymentTokens {
        nextToken
        __typename
      }
      DealAppointments {
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      pinAddress {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      tags {
        nextToken
        __typename
      }
      transactions {
        nextToken
        __typename
      }
      ownerHistory {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      files {
        nextToken
        __typename
      }
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        requireCloser
        sendToCRM
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      actions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createDealTransactions = /* GraphQL */ `
  mutation CreateDealTransactions(
    $input: CreateDealTransactionsInput!
    $condition: ModelDealTransactionsConditionInput
  ) {
    createDealTransactions(input: $input, condition: $condition) {
      id
      dealID
      orgID
      flexAttributes
      currentDispositionID
      currentOwnerID
      currentStageID
      officeID
      isReversal
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      isNewDeal
      queuedForRulesEngine
      actualTimestamp
      source
      rulesEngineStartTime
      rulesEngineEndTime
      ErrorMessage
      __typename
    }
  }
`;
export const updateDealTransactions = /* GraphQL */ `
  mutation UpdateDealTransactions(
    $input: UpdateDealTransactionsInput!
    $condition: ModelDealTransactionsConditionInput
  ) {
    updateDealTransactions(input: $input, condition: $condition) {
      id
      dealID
      orgID
      flexAttributes
      currentDispositionID
      currentOwnerID
      currentStageID
      officeID
      isReversal
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      isNewDeal
      queuedForRulesEngine
      actualTimestamp
      source
      rulesEngineStartTime
      rulesEngineEndTime
      ErrorMessage
      __typename
    }
  }
`;
export const deleteDealTransactions = /* GraphQL */ `
  mutation DeleteDealTransactions(
    $input: DeleteDealTransactionsInput!
    $condition: ModelDealTransactionsConditionInput
  ) {
    deleteDealTransactions(input: $input, condition: $condition) {
      id
      dealID
      orgID
      flexAttributes
      currentDispositionID
      currentOwnerID
      currentStageID
      officeID
      isReversal
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      isNewDeal
      queuedForRulesEngine
      actualTimestamp
      source
      rulesEngineStartTime
      rulesEngineEndTime
      ErrorMessage
      __typename
    }
  }
`;
export const createDealStageHistory = /* GraphQL */ `
  mutation CreateDealStageHistory(
    $input: CreateDealStageHistoryInput!
    $condition: ModelDealStageHistoryConditionInput
  ) {
    createDealStageHistory(input: $input, condition: $condition) {
      id
      dealID
      stageID
      rulesEngineProcessed
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateDealStageHistory = /* GraphQL */ `
  mutation UpdateDealStageHistory(
    $input: UpdateDealStageHistoryInput!
    $condition: ModelDealStageHistoryConditionInput
  ) {
    updateDealStageHistory(input: $input, condition: $condition) {
      id
      dealID
      stageID
      rulesEngineProcessed
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteDealStageHistory = /* GraphQL */ `
  mutation DeleteDealStageHistory(
    $input: DeleteDealStageHistoryInput!
    $condition: ModelDealStageHistoryConditionInput
  ) {
    deleteDealStageHistory(input: $input, condition: $condition) {
      id
      dealID
      stageID
      rulesEngineProcessed
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createDealOwnerHistory = /* GraphQL */ `
  mutation CreateDealOwnerHistory(
    $input: CreateDealOwnerHistoryInput!
    $condition: ModelDealOwnerHistoryConditionInput
  ) {
    createDealOwnerHistory(input: $input, condition: $condition) {
      id
      dealID
      orgID
      userID
      ownerType
      isActive
      percent
      isCalculateKPIs
      isMissionCredit
      notes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateDealOwnerHistory = /* GraphQL */ `
  mutation UpdateDealOwnerHistory(
    $input: UpdateDealOwnerHistoryInput!
    $condition: ModelDealOwnerHistoryConditionInput
  ) {
    updateDealOwnerHistory(input: $input, condition: $condition) {
      id
      dealID
      orgID
      userID
      ownerType
      isActive
      percent
      isCalculateKPIs
      isMissionCredit
      notes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteDealOwnerHistory = /* GraphQL */ `
  mutation DeleteDealOwnerHistory(
    $input: DeleteDealOwnerHistoryInput!
    $condition: ModelDealOwnerHistoryConditionInput
  ) {
    deleteDealOwnerHistory(input: $input, condition: $condition) {
      id
      dealID
      orgID
      userID
      ownerType
      isActive
      percent
      isCalculateKPIs
      isMissionCredit
      notes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createDealComments = /* GraphQL */ `
  mutation CreateDealComments(
    $input: CreateDealCommentsInput!
    $condition: ModelDealCommentsConditionInput
  ) {
    createDealComments(input: $input, condition: $condition) {
      id
      orgID
      dealID
      type
      comment
      timestampedComment
      summary
      actionItems
      audioDisplayName
      transcriber
      AAITranscriptID
      audioName
      audioLength
      audioType
      dispositionID
      followupDate
      contactType
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateDealComments = /* GraphQL */ `
  mutation UpdateDealComments(
    $input: UpdateDealCommentsInput!
    $condition: ModelDealCommentsConditionInput
  ) {
    updateDealComments(input: $input, condition: $condition) {
      id
      orgID
      dealID
      type
      comment
      timestampedComment
      summary
      actionItems
      audioDisplayName
      transcriber
      AAITranscriptID
      audioName
      audioLength
      audioType
      dispositionID
      followupDate
      contactType
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteDealComments = /* GraphQL */ `
  mutation DeleteDealComments(
    $input: DeleteDealCommentsInput!
    $condition: ModelDealCommentsConditionInput
  ) {
    deleteDealComments(input: $input, condition: $condition) {
      id
      orgID
      dealID
      type
      comment
      timestampedComment
      summary
      actionItems
      audioDisplayName
      transcriber
      AAITranscriptID
      audioName
      audioLength
      audioType
      dispositionID
      followupDate
      contactType
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createRecordingComments = /* GraphQL */ `
  mutation CreateRecordingComments(
    $input: CreateRecordingCommentsInput!
    $condition: ModelRecordingCommentsConditionInput
  ) {
    createRecordingComments(input: $input, condition: $condition) {
      id
      orgID
      recordingID
      comment
      timestamp
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      recording {
        id
        orgID
        dealID
        type
        comment
        timestampedComment
        summary
        actionItems
        audioDisplayName
        transcriber
        AAITranscriptID
        audioName
        audioLength
        audioType
        dispositionID
        followupDate
        contactType
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateRecordingComments = /* GraphQL */ `
  mutation UpdateRecordingComments(
    $input: UpdateRecordingCommentsInput!
    $condition: ModelRecordingCommentsConditionInput
  ) {
    updateRecordingComments(input: $input, condition: $condition) {
      id
      orgID
      recordingID
      comment
      timestamp
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      recording {
        id
        orgID
        dealID
        type
        comment
        timestampedComment
        summary
        actionItems
        audioDisplayName
        transcriber
        AAITranscriptID
        audioName
        audioLength
        audioType
        dispositionID
        followupDate
        contactType
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteRecordingComments = /* GraphQL */ `
  mutation DeleteRecordingComments(
    $input: DeleteRecordingCommentsInput!
    $condition: ModelRecordingCommentsConditionInput
  ) {
    deleteRecordingComments(input: $input, condition: $condition) {
      id
      orgID
      recordingID
      comment
      timestamp
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      recording {
        id
        orgID
        dealID
        type
        comment
        timestampedComment
        summary
        actionItems
        audioDisplayName
        transcriber
        AAITranscriptID
        audioName
        audioLength
        audioType
        dispositionID
        followupDate
        contactType
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createDealFile = /* GraphQL */ `
  mutation CreateDealFile(
    $input: CreateDealFileInput!
    $condition: ModelDealFileConditionInput
  ) {
    createDealFile(input: $input, condition: $condition) {
      id
      orgID
      dealID
      reportID
      description
      tags
      category
      locationText
      location {
        lat
        lon
        __typename
      }
      type
      url
      sequence
      createdBy
      lastUpdatedBy
      fileTimestampEpoch
      createdAt
      updatedAt
      isDeleted
      comments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateDealFile = /* GraphQL */ `
  mutation UpdateDealFile(
    $input: UpdateDealFileInput!
    $condition: ModelDealFileConditionInput
  ) {
    updateDealFile(input: $input, condition: $condition) {
      id
      orgID
      dealID
      reportID
      description
      tags
      category
      locationText
      location {
        lat
        lon
        __typename
      }
      type
      url
      sequence
      createdBy
      lastUpdatedBy
      fileTimestampEpoch
      createdAt
      updatedAt
      isDeleted
      comments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteDealFile = /* GraphQL */ `
  mutation DeleteDealFile(
    $input: DeleteDealFileInput!
    $condition: ModelDealFileConditionInput
  ) {
    deleteDealFile(input: $input, condition: $condition) {
      id
      orgID
      dealID
      reportID
      description
      tags
      category
      locationText
      location {
        lat
        lon
        __typename
      }
      type
      url
      sequence
      createdBy
      lastUpdatedBy
      fileTimestampEpoch
      createdAt
      updatedAt
      isDeleted
      comments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createDealFileComment = /* GraphQL */ `
  mutation CreateDealFileComment(
    $input: CreateDealFileCommentInput!
    $condition: ModelDealFileCommentConditionInput
  ) {
    createDealFileComment(input: $input, condition: $condition) {
      id
      orgID
      reportID
      isInternalOnly
      comment
      name
      contactInformation
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateDealFileComment = /* GraphQL */ `
  mutation UpdateDealFileComment(
    $input: UpdateDealFileCommentInput!
    $condition: ModelDealFileCommentConditionInput
  ) {
    updateDealFileComment(input: $input, condition: $condition) {
      id
      orgID
      reportID
      isInternalOnly
      comment
      name
      contactInformation
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteDealFileComment = /* GraphQL */ `
  mutation DeleteDealFileComment(
    $input: DeleteDealFileCommentInput!
    $condition: ModelDealFileCommentConditionInput
  ) {
    deleteDealFileComment(input: $input, condition: $condition) {
      id
      orgID
      reportID
      isInternalOnly
      comment
      name
      contactInformation
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createDealType = /* GraphQL */ `
  mutation CreateDealType(
    $input: CreateDealTypeInput!
    $condition: ModelDealTypeConditionInput
  ) {
    createDealType(input: $input, condition: $condition) {
      id
      orgID
      title
      formID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateDealType = /* GraphQL */ `
  mutation UpdateDealType(
    $input: UpdateDealTypeInput!
    $condition: ModelDealTypeConditionInput
  ) {
    updateDealType(input: $input, condition: $condition) {
      id
      orgID
      title
      formID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteDealType = /* GraphQL */ `
  mutation DeleteDealType(
    $input: DeleteDealTypeInput!
    $condition: ModelDealTypeConditionInput
  ) {
    deleteDealType(input: $input, condition: $condition) {
      id
      orgID
      title
      formID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createStageGoal = /* GraphQL */ `
  mutation CreateStageGoal(
    $input: CreateStageGoalInput!
    $condition: ModelStageGoalConditionInput
  ) {
    createStageGoal(input: $input, condition: $condition) {
      id
      orgID
      ownerID
      ownerType
      stageID
      goalCount
      goalValue
      startDate
      endDate
      frequency
      parentStageGoalID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        requireCloser
        sendToCRM
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateStageGoal = /* GraphQL */ `
  mutation UpdateStageGoal(
    $input: UpdateStageGoalInput!
    $condition: ModelStageGoalConditionInput
  ) {
    updateStageGoal(input: $input, condition: $condition) {
      id
      orgID
      ownerID
      ownerType
      stageID
      goalCount
      goalValue
      startDate
      endDate
      frequency
      parentStageGoalID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        requireCloser
        sendToCRM
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteStageGoal = /* GraphQL */ `
  mutation DeleteStageGoal(
    $input: DeleteStageGoalInput!
    $condition: ModelStageGoalConditionInput
  ) {
    deleteStageGoal(input: $input, condition: $condition) {
      id
      orgID
      ownerID
      ownerType
      stageID
      goalCount
      goalValue
      startDate
      endDate
      frequency
      parentStageGoalID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        requireCloser
        sendToCRM
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createKPIRuleGoal = /* GraphQL */ `
  mutation CreateKPIRuleGoal(
    $input: CreateKPIRuleGoalInput!
    $condition: ModelKPIRuleGoalConditionInput
  ) {
    createKPIRuleGoal(input: $input, condition: $condition) {
      id
      orgID
      dimensionID
      KPIRuleID
      value
      parentKPIRuleID
      dimension
      startDate
      endDate
      frequency
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      parentKPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateKPIRuleGoal = /* GraphQL */ `
  mutation UpdateKPIRuleGoal(
    $input: UpdateKPIRuleGoalInput!
    $condition: ModelKPIRuleGoalConditionInput
  ) {
    updateKPIRuleGoal(input: $input, condition: $condition) {
      id
      orgID
      dimensionID
      KPIRuleID
      value
      parentKPIRuleID
      dimension
      startDate
      endDate
      frequency
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      parentKPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteKPIRuleGoal = /* GraphQL */ `
  mutation DeleteKPIRuleGoal(
    $input: DeleteKPIRuleGoalInput!
    $condition: ModelKPIRuleGoalConditionInput
  ) {
    deleteKPIRuleGoal(input: $input, condition: $condition) {
      id
      orgID
      dimensionID
      KPIRuleID
      value
      parentKPIRuleID
      dimension
      startDate
      endDate
      frequency
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      parentKPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createForm = /* GraphQL */ `
  mutation CreateForm(
    $input: CreateFormInput!
    $condition: ModelFormConditionInput
  ) {
    createForm(input: $input, condition: $condition) {
      id
      orgID
      title
      flexAttributes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateForm = /* GraphQL */ `
  mutation UpdateForm(
    $input: UpdateFormInput!
    $condition: ModelFormConditionInput
  ) {
    updateForm(input: $input, condition: $condition) {
      id
      orgID
      title
      flexAttributes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteForm = /* GraphQL */ `
  mutation DeleteForm(
    $input: DeleteFormInput!
    $condition: ModelFormConditionInput
  ) {
    deleteForm(input: $input, condition: $condition) {
      id
      orgID
      title
      flexAttributes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createStage = /* GraphQL */ `
  mutation CreateStage(
    $input: CreateStageInput!
    $condition: ModelStageConditionInput
  ) {
    createStage(input: $input, condition: $condition) {
      id
      orgID
      title
      dealTypeID
      description
      userSelectable
      changeToDispositionID
      setStages
      clearStages
      reverseIDs
      action
      actionPastTense
      measure
      measurePlural
      valueUnit
      valueUnitPlural
      countUnit
      countUnitPlural
      iconName
      iconType
      iconColor
      flexAttributes
      sequence
      winProbability
      pinColor
      icon
      isMapDefault
      isDisplay
      isActive
      isNoDealDefault
      requireCloser
      sendToCRM
      calendarAppointmentStatus
      categoryID
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateStage = /* GraphQL */ `
  mutation UpdateStage(
    $input: UpdateStageInput!
    $condition: ModelStageConditionInput
  ) {
    updateStage(input: $input, condition: $condition) {
      id
      orgID
      title
      dealTypeID
      description
      userSelectable
      changeToDispositionID
      setStages
      clearStages
      reverseIDs
      action
      actionPastTense
      measure
      measurePlural
      valueUnit
      valueUnitPlural
      countUnit
      countUnitPlural
      iconName
      iconType
      iconColor
      flexAttributes
      sequence
      winProbability
      pinColor
      icon
      isMapDefault
      isDisplay
      isActive
      isNoDealDefault
      requireCloser
      sendToCRM
      calendarAppointmentStatus
      categoryID
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteStage = /* GraphQL */ `
  mutation DeleteStage(
    $input: DeleteStageInput!
    $condition: ModelStageConditionInput
  ) {
    deleteStage(input: $input, condition: $condition) {
      id
      orgID
      title
      dealTypeID
      description
      userSelectable
      changeToDispositionID
      setStages
      clearStages
      reverseIDs
      action
      actionPastTense
      measure
      measurePlural
      valueUnit
      valueUnitPlural
      countUnit
      countUnitPlural
      iconName
      iconType
      iconColor
      flexAttributes
      sequence
      winProbability
      pinColor
      icon
      isMapDefault
      isDisplay
      isActive
      isNoDealDefault
      requireCloser
      sendToCRM
      calendarAppointmentStatus
      categoryID
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createStageCategory = /* GraphQL */ `
  mutation CreateStageCategory(
    $input: CreateStageCategoryInput!
    $condition: ModelStageCategoryConditionInput
  ) {
    createStageCategory(input: $input, condition: $condition) {
      id
      orgID
      title
      iconName
      iconType
      iconColor
      isDefault
      enablePindrop
      enableDeal
      defaultProductFamily
      flexAttributes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      stages {
        nextToken
        __typename
      }
      dispositions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateStageCategory = /* GraphQL */ `
  mutation UpdateStageCategory(
    $input: UpdateStageCategoryInput!
    $condition: ModelStageCategoryConditionInput
  ) {
    updateStageCategory(input: $input, condition: $condition) {
      id
      orgID
      title
      iconName
      iconType
      iconColor
      isDefault
      enablePindrop
      enableDeal
      defaultProductFamily
      flexAttributes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      stages {
        nextToken
        __typename
      }
      dispositions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteStageCategory = /* GraphQL */ `
  mutation DeleteStageCategory(
    $input: DeleteStageCategoryInput!
    $condition: ModelStageCategoryConditionInput
  ) {
    deleteStageCategory(input: $input, condition: $condition) {
      id
      orgID
      title
      iconName
      iconType
      iconColor
      isDefault
      enablePindrop
      enableDeal
      defaultProductFamily
      flexAttributes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      stages {
        nextToken
        __typename
      }
      dispositions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createStageDisposition = /* GraphQL */ `
  mutation CreateStageDisposition(
    $input: CreateStageDispositionInput!
    $condition: ModelStageDispositionConditionInput
  ) {
    createStageDisposition(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      title
      formName
      stageID
      isSetupDeal
      requireDate
      isDefault
      noRecording
      isConversation
      isNotSelectable
      isNonMapDefault
      deleteType
      groupID
      order
      expiresIn
      commentsAtTop
      iconName
      iconType
      iconColor
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateStageDisposition = /* GraphQL */ `
  mutation UpdateStageDisposition(
    $input: UpdateStageDispositionInput!
    $condition: ModelStageDispositionConditionInput
  ) {
    updateStageDisposition(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      title
      formName
      stageID
      isSetupDeal
      requireDate
      isDefault
      noRecording
      isConversation
      isNotSelectable
      isNonMapDefault
      deleteType
      groupID
      order
      expiresIn
      commentsAtTop
      iconName
      iconType
      iconColor
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteStageDisposition = /* GraphQL */ `
  mutation DeleteStageDisposition(
    $input: DeleteStageDispositionInput!
    $condition: ModelStageDispositionConditionInput
  ) {
    deleteStageDisposition(input: $input, condition: $condition) {
      id
      orgID
      categoryID
      title
      formName
      stageID
      isSetupDeal
      requireDate
      isDefault
      noRecording
      isConversation
      isNotSelectable
      isNonMapDefault
      deleteType
      groupID
      order
      expiresIn
      commentsAtTop
      iconName
      iconType
      iconColor
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createTrophy = /* GraphQL */ `
  mutation CreateTrophy(
    $input: CreateTrophyInput!
    $condition: ModelTrophyConditionInput
  ) {
    createTrophy(input: $input, condition: $condition) {
      id
      orgID
      title
      description
      imageName
      imageType
      place
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateTrophy = /* GraphQL */ `
  mutation UpdateTrophy(
    $input: UpdateTrophyInput!
    $condition: ModelTrophyConditionInput
  ) {
    updateTrophy(input: $input, condition: $condition) {
      id
      orgID
      title
      description
      imageName
      imageType
      place
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteTrophy = /* GraphQL */ `
  mutation DeleteTrophy(
    $input: DeleteTrophyInput!
    $condition: ModelTrophyConditionInput
  ) {
    deleteTrophy(input: $input, condition: $condition) {
      id
      orgID
      title
      description
      imageName
      imageType
      place
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createMissionTrophy = /* GraphQL */ `
  mutation CreateMissionTrophy(
    $input: CreateMissionTrophyInput!
    $condition: ModelMissionTrophyConditionInput
  ) {
    createMissionTrophy(input: $input, condition: $condition) {
      id
      orgID
      missionID
      title
      description
      imageName
      imageType
      place
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateMissionTrophy = /* GraphQL */ `
  mutation UpdateMissionTrophy(
    $input: UpdateMissionTrophyInput!
    $condition: ModelMissionTrophyConditionInput
  ) {
    updateMissionTrophy(input: $input, condition: $condition) {
      id
      orgID
      missionID
      title
      description
      imageName
      imageType
      place
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteMissionTrophy = /* GraphQL */ `
  mutation DeleteMissionTrophy(
    $input: DeleteMissionTrophyInput!
    $condition: ModelMissionTrophyConditionInput
  ) {
    deleteMissionTrophy(input: $input, condition: $condition) {
      id
      orgID
      missionID
      title
      description
      imageName
      imageType
      place
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createPersonTrophy = /* GraphQL */ `
  mutation CreatePersonTrophy(
    $input: CreatePersonTrophyInput!
    $condition: ModelPersonTrophyConditionInput
  ) {
    createPersonTrophy(input: $input, condition: $condition) {
      id
      orgID
      userID
      count
      title
      description
      imageName
      imageType
      place
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updatePersonTrophy = /* GraphQL */ `
  mutation UpdatePersonTrophy(
    $input: UpdatePersonTrophyInput!
    $condition: ModelPersonTrophyConditionInput
  ) {
    updatePersonTrophy(input: $input, condition: $condition) {
      id
      orgID
      userID
      count
      title
      description
      imageName
      imageType
      place
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deletePersonTrophy = /* GraphQL */ `
  mutation DeletePersonTrophy(
    $input: DeletePersonTrophyInput!
    $condition: ModelPersonTrophyConditionInput
  ) {
    deletePersonTrophy(input: $input, condition: $condition) {
      id
      orgID
      userID
      count
      title
      description
      imageName
      imageType
      place
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createKPIRule = /* GraphQL */ `
  mutation CreateKPIRule(
    $input: CreateKPIRuleInput!
    $condition: ModelKPIRuleConditionInput
  ) {
    createKPIRule(input: $input, condition: $condition) {
      id
      orgID
      type
      timeframe
      title
      abbreviation
      sourceType
      formula
      triggerID
      dimensions
      action
      actionPastTense
      valueUnit
      valueUnitPlural
      categoryID
      viewerRoles
      leaderboardViewerRoles
      scorecardViewerRoles
      order
      editorRoles
      functionalRoles
      eventCreatorScope
      entitlement
      isHidden
      useDateOfStage
      format
      roundPrecision
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      goals {
        nextToken
        __typename
      }
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        requireCloser
        sendToCRM
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      aggs {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateKPIRule = /* GraphQL */ `
  mutation UpdateKPIRule(
    $input: UpdateKPIRuleInput!
    $condition: ModelKPIRuleConditionInput
  ) {
    updateKPIRule(input: $input, condition: $condition) {
      id
      orgID
      type
      timeframe
      title
      abbreviation
      sourceType
      formula
      triggerID
      dimensions
      action
      actionPastTense
      valueUnit
      valueUnitPlural
      categoryID
      viewerRoles
      leaderboardViewerRoles
      scorecardViewerRoles
      order
      editorRoles
      functionalRoles
      eventCreatorScope
      entitlement
      isHidden
      useDateOfStage
      format
      roundPrecision
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      goals {
        nextToken
        __typename
      }
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        requireCloser
        sendToCRM
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      aggs {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteKPIRule = /* GraphQL */ `
  mutation DeleteKPIRule(
    $input: DeleteKPIRuleInput!
    $condition: ModelKPIRuleConditionInput
  ) {
    deleteKPIRule(input: $input, condition: $condition) {
      id
      orgID
      type
      timeframe
      title
      abbreviation
      sourceType
      formula
      triggerID
      dimensions
      action
      actionPastTense
      valueUnit
      valueUnitPlural
      categoryID
      viewerRoles
      leaderboardViewerRoles
      scorecardViewerRoles
      order
      editorRoles
      functionalRoles
      eventCreatorScope
      entitlement
      isHidden
      useDateOfStage
      format
      roundPrecision
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      goals {
        nextToken
        __typename
      }
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        requireCloser
        sendToCRM
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      aggs {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createKPIValueAggs = /* GraphQL */ `
  mutation CreateKPIValueAggs(
    $input: CreateKPIValueAggsInput!
    $condition: ModelKPIValueAggsConditionInput
  ) {
    createKPIValueAggs(input: $input, condition: $condition) {
      id
      orgID
      userKey
      count
      sum
      val
      goal
      dimensionID
      KPIRuleID
      dimension
      currentPosition
      previousPosition
      mostRecentDimensionID
      leaderboard
      isDeleted
      createdAt
      updatedAt
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateKPIValueAggs = /* GraphQL */ `
  mutation UpdateKPIValueAggs(
    $input: UpdateKPIValueAggsInput!
    $condition: ModelKPIValueAggsConditionInput
  ) {
    updateKPIValueAggs(input: $input, condition: $condition) {
      id
      orgID
      userKey
      count
      sum
      val
      goal
      dimensionID
      KPIRuleID
      dimension
      currentPosition
      previousPosition
      mostRecentDimensionID
      leaderboard
      isDeleted
      createdAt
      updatedAt
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteKPIValueAggs = /* GraphQL */ `
  mutation DeleteKPIValueAggs(
    $input: DeleteKPIValueAggsInput!
    $condition: ModelKPIValueAggsConditionInput
  ) {
    deleteKPIValueAggs(input: $input, condition: $condition) {
      id
      orgID
      userKey
      count
      sum
      val
      goal
      dimensionID
      KPIRuleID
      dimension
      currentPosition
      previousPosition
      mostRecentDimensionID
      leaderboard
      isDeleted
      createdAt
      updatedAt
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createKPIValueAggsTransactions = /* GraphQL */ `
  mutation CreateKPIValueAggsTransactions(
    $input: CreateKPIValueAggsTransactionsInput!
    $condition: ModelKPIValueAggsTransactionsConditionInput
  ) {
    createKPIValueAggsTransactions(input: $input, condition: $condition) {
      id
      KPIValueAggsID
      inputValue
      dealID
      dealTransactionsID
      orgID
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      dealTransaction {
        id
        dealID
        orgID
        flexAttributes
        currentDispositionID
        currentOwnerID
        currentStageID
        officeID
        isReversal
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isNewDeal
        queuedForRulesEngine
        actualTimestamp
        source
        rulesEngineStartTime
        rulesEngineEndTime
        ErrorMessage
        __typename
      }
      KPIValueAgg {
        id
        orgID
        userKey
        count
        sum
        val
        goal
        dimensionID
        KPIRuleID
        dimension
        currentPosition
        previousPosition
        mostRecentDimensionID
        leaderboard
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateKPIValueAggsTransactions = /* GraphQL */ `
  mutation UpdateKPIValueAggsTransactions(
    $input: UpdateKPIValueAggsTransactionsInput!
    $condition: ModelKPIValueAggsTransactionsConditionInput
  ) {
    updateKPIValueAggsTransactions(input: $input, condition: $condition) {
      id
      KPIValueAggsID
      inputValue
      dealID
      dealTransactionsID
      orgID
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      dealTransaction {
        id
        dealID
        orgID
        flexAttributes
        currentDispositionID
        currentOwnerID
        currentStageID
        officeID
        isReversal
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isNewDeal
        queuedForRulesEngine
        actualTimestamp
        source
        rulesEngineStartTime
        rulesEngineEndTime
        ErrorMessage
        __typename
      }
      KPIValueAgg {
        id
        orgID
        userKey
        count
        sum
        val
        goal
        dimensionID
        KPIRuleID
        dimension
        currentPosition
        previousPosition
        mostRecentDimensionID
        leaderboard
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteKPIValueAggsTransactions = /* GraphQL */ `
  mutation DeleteKPIValueAggsTransactions(
    $input: DeleteKPIValueAggsTransactionsInput!
    $condition: ModelKPIValueAggsTransactionsConditionInput
  ) {
    deleteKPIValueAggsTransactions(input: $input, condition: $condition) {
      id
      KPIValueAggsID
      inputValue
      dealID
      dealTransactionsID
      orgID
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      dealTransaction {
        id
        dealID
        orgID
        flexAttributes
        currentDispositionID
        currentOwnerID
        currentStageID
        officeID
        isReversal
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isNewDeal
        queuedForRulesEngine
        actualTimestamp
        source
        rulesEngineStartTime
        rulesEngineEndTime
        ErrorMessage
        __typename
      }
      KPIValueAgg {
        id
        orgID
        userKey
        count
        sum
        val
        goal
        dimensionID
        KPIRuleID
        dimension
        currentPosition
        previousPosition
        mostRecentDimensionID
        leaderboard
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createPersonActivityFeed = /* GraphQL */ `
  mutation CreatePersonActivityFeed(
    $input: CreatePersonActivityFeedInput!
    $condition: ModelPersonActivityFeedConditionInput
  ) {
    createPersonActivityFeed(input: $input, condition: $condition) {
      id
      userID
      isRead
      orgID
      type
      showAfter
      showAfterEpoch
      showUntilEpoch
      extID
      createdAt
      updatedAt
      isDeleted
      activityFeed {
        id
        event
        header
        details
        imageName
        imageType
        chartType
        chartData
        orgID
        type
        showAfterEpoch
        showUntilEpoch
        showAfter
        extID
        createdAt
        createdBy
        changedID
        updatedAt
        lastUpdatedBy
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updatePersonActivityFeed = /* GraphQL */ `
  mutation UpdatePersonActivityFeed(
    $input: UpdatePersonActivityFeedInput!
    $condition: ModelPersonActivityFeedConditionInput
  ) {
    updatePersonActivityFeed(input: $input, condition: $condition) {
      id
      userID
      isRead
      orgID
      type
      showAfter
      showAfterEpoch
      showUntilEpoch
      extID
      createdAt
      updatedAt
      isDeleted
      activityFeed {
        id
        event
        header
        details
        imageName
        imageType
        chartType
        chartData
        orgID
        type
        showAfterEpoch
        showUntilEpoch
        showAfter
        extID
        createdAt
        createdBy
        changedID
        updatedAt
        lastUpdatedBy
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deletePersonActivityFeed = /* GraphQL */ `
  mutation DeletePersonActivityFeed(
    $input: DeletePersonActivityFeedInput!
    $condition: ModelPersonActivityFeedConditionInput
  ) {
    deletePersonActivityFeed(input: $input, condition: $condition) {
      id
      userID
      isRead
      orgID
      type
      showAfter
      showAfterEpoch
      showUntilEpoch
      extID
      createdAt
      updatedAt
      isDeleted
      activityFeed {
        id
        event
        header
        details
        imageName
        imageType
        chartType
        chartData
        orgID
        type
        showAfterEpoch
        showUntilEpoch
        showAfter
        extID
        createdAt
        createdBy
        changedID
        updatedAt
        lastUpdatedBy
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createCircleActivityFeed = /* GraphQL */ `
  mutation CreateCircleActivityFeed(
    $input: CreateCircleActivityFeedInput!
    $condition: ModelCircleActivityFeedConditionInput
  ) {
    createCircleActivityFeed(input: $input, condition: $condition) {
      id
      activityFeedID
      circleID
      orgID
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateCircleActivityFeed = /* GraphQL */ `
  mutation UpdateCircleActivityFeed(
    $input: UpdateCircleActivityFeedInput!
    $condition: ModelCircleActivityFeedConditionInput
  ) {
    updateCircleActivityFeed(input: $input, condition: $condition) {
      id
      activityFeedID
      circleID
      orgID
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteCircleActivityFeed = /* GraphQL */ `
  mutation DeleteCircleActivityFeed(
    $input: DeleteCircleActivityFeedInput!
    $condition: ModelCircleActivityFeedConditionInput
  ) {
    deleteCircleActivityFeed(input: $input, condition: $condition) {
      id
      activityFeedID
      circleID
      orgID
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createActivityFeed = /* GraphQL */ `
  mutation CreateActivityFeed(
    $input: CreateActivityFeedInput!
    $condition: ModelActivityFeedConditionInput
  ) {
    createActivityFeed(input: $input, condition: $condition) {
      id
      event
      header
      details
      imageName
      imageType
      chartType
      chartData
      orgID
      type
      showAfterEpoch
      showUntilEpoch
      showAfter
      extID
      createdAt
      createdBy
      changedID
      updatedAt
      lastUpdatedBy
      isDeleted
      people {
        nextToken
        __typename
      }
      emoticons {
        nextToken
        __typename
      }
      changedEmoticon {
        id
        activityFeedID
        type
        userID
        orgID
        createdAt
        isDeleted
        updatedAt
        __typename
      }
      changedCommentEmoticon {
        id
        commentID
        type
        userID
        orgID
        createdAt
        isDeleted
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      changedComment {
        id
        content
        userID
        imageName
        imageType
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      createdByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateActivityFeed = /* GraphQL */ `
  mutation UpdateActivityFeed(
    $input: UpdateActivityFeedInput!
    $condition: ModelActivityFeedConditionInput
  ) {
    updateActivityFeed(input: $input, condition: $condition) {
      id
      event
      header
      details
      imageName
      imageType
      chartType
      chartData
      orgID
      type
      showAfterEpoch
      showUntilEpoch
      showAfter
      extID
      createdAt
      createdBy
      changedID
      updatedAt
      lastUpdatedBy
      isDeleted
      people {
        nextToken
        __typename
      }
      emoticons {
        nextToken
        __typename
      }
      changedEmoticon {
        id
        activityFeedID
        type
        userID
        orgID
        createdAt
        isDeleted
        updatedAt
        __typename
      }
      changedCommentEmoticon {
        id
        commentID
        type
        userID
        orgID
        createdAt
        isDeleted
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      changedComment {
        id
        content
        userID
        imageName
        imageType
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      createdByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteActivityFeed = /* GraphQL */ `
  mutation DeleteActivityFeed(
    $input: DeleteActivityFeedInput!
    $condition: ModelActivityFeedConditionInput
  ) {
    deleteActivityFeed(input: $input, condition: $condition) {
      id
      event
      header
      details
      imageName
      imageType
      chartType
      chartData
      orgID
      type
      showAfterEpoch
      showUntilEpoch
      showAfter
      extID
      createdAt
      createdBy
      changedID
      updatedAt
      lastUpdatedBy
      isDeleted
      people {
        nextToken
        __typename
      }
      emoticons {
        nextToken
        __typename
      }
      changedEmoticon {
        id
        activityFeedID
        type
        userID
        orgID
        createdAt
        isDeleted
        updatedAt
        __typename
      }
      changedCommentEmoticon {
        id
        commentID
        type
        userID
        orgID
        createdAt
        isDeleted
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      changedComment {
        id
        content
        userID
        imageName
        imageType
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      createdByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createActivityFeedEmoticon = /* GraphQL */ `
  mutation CreateActivityFeedEmoticon(
    $input: CreateActivityFeedEmoticonInput!
    $condition: ModelActivityFeedEmoticonConditionInput
  ) {
    createActivityFeedEmoticon(input: $input, condition: $condition) {
      id
      activityFeedID
      type
      userID
      orgID
      createdAt
      isDeleted
      updatedAt
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateActivityFeedEmoticon = /* GraphQL */ `
  mutation UpdateActivityFeedEmoticon(
    $input: UpdateActivityFeedEmoticonInput!
    $condition: ModelActivityFeedEmoticonConditionInput
  ) {
    updateActivityFeedEmoticon(input: $input, condition: $condition) {
      id
      activityFeedID
      type
      userID
      orgID
      createdAt
      isDeleted
      updatedAt
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteActivityFeedEmoticon = /* GraphQL */ `
  mutation DeleteActivityFeedEmoticon(
    $input: DeleteActivityFeedEmoticonInput!
    $condition: ModelActivityFeedEmoticonConditionInput
  ) {
    deleteActivityFeedEmoticon(input: $input, condition: $condition) {
      id
      activityFeedID
      type
      userID
      orgID
      createdAt
      isDeleted
      updatedAt
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createCommentEmoticon = /* GraphQL */ `
  mutation CreateCommentEmoticon(
    $input: CreateCommentEmoticonInput!
    $condition: ModelCommentEmoticonConditionInput
  ) {
    createCommentEmoticon(input: $input, condition: $condition) {
      id
      commentID
      type
      userID
      orgID
      createdAt
      isDeleted
      updatedAt
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateCommentEmoticon = /* GraphQL */ `
  mutation UpdateCommentEmoticon(
    $input: UpdateCommentEmoticonInput!
    $condition: ModelCommentEmoticonConditionInput
  ) {
    updateCommentEmoticon(input: $input, condition: $condition) {
      id
      commentID
      type
      userID
      orgID
      createdAt
      isDeleted
      updatedAt
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteCommentEmoticon = /* GraphQL */ `
  mutation DeleteCommentEmoticon(
    $input: DeleteCommentEmoticonInput!
    $condition: ModelCommentEmoticonConditionInput
  ) {
    deleteCommentEmoticon(input: $input, condition: $condition) {
      id
      commentID
      type
      userID
      orgID
      createdAt
      isDeleted
      updatedAt
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      id
      content
      userID
      imageName
      imageType
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      activityFeed {
        id
        event
        header
        details
        imageName
        imageType
        chartType
        chartData
        orgID
        type
        showAfterEpoch
        showUntilEpoch
        showAfter
        extID
        createdAt
        createdBy
        changedID
        updatedAt
        lastUpdatedBy
        isDeleted
        __typename
      }
      emoticons {
        nextToken
        __typename
      }
      parentComment {
        id
        content
        userID
        imageName
        imageType
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      comments {
        nextToken
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      id
      content
      userID
      imageName
      imageType
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      activityFeed {
        id
        event
        header
        details
        imageName
        imageType
        chartType
        chartData
        orgID
        type
        showAfterEpoch
        showUntilEpoch
        showAfter
        extID
        createdAt
        createdBy
        changedID
        updatedAt
        lastUpdatedBy
        isDeleted
        __typename
      }
      emoticons {
        nextToken
        __typename
      }
      parentComment {
        id
        content
        userID
        imageName
        imageType
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      comments {
        nextToken
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      id
      content
      userID
      imageName
      imageType
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      activityFeed {
        id
        event
        header
        details
        imageName
        imageType
        chartType
        chartData
        orgID
        type
        showAfterEpoch
        showUntilEpoch
        showAfter
        extID
        createdAt
        createdBy
        changedID
        updatedAt
        lastUpdatedBy
        isDeleted
        __typename
      }
      emoticons {
        nextToken
        __typename
      }
      parentComment {
        id
        content
        userID
        imageName
        imageType
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      comments {
        nextToken
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createMission = /* GraphQL */ `
  mutation CreateMission(
    $input: CreateMissionInput!
    $condition: ModelMissionConditionInput
  ) {
    createMission(input: $input, condition: $condition) {
      id
      type
      contestType
      name
      description
      rewardLimit
      rewardCount
      rewardType
      actionPastTense
      actionTypePlural
      rewardID
      rewardName
      scope
      ownerID
      ownerType
      startDate
      endDate
      launchDate
      startDateEpoch
      endDateEpoch
      launchDateEpoch
      KPIRuleID
      tieKPIRuleID
      imageName
      imageType
      questType
      questOrder
      location
      actionCount
      action
      actionType
      minGoal
      actionCountType
      completePictureRequired
      isDeleted
      nextLaunchFeedBlast
      nextExpireFeedBlast
      tags
      rules {
        id
        multiplier
        name
        role
        goal
        sequence
        __typename
      }
      bracket
      orgID
      mostRecentUserID
      trophiesAwarded
      rewardsAwarded
      bracketWinner
      autoAssign
      assignToChildCircles
      autoCreateMonths
      permissions
      categoryID
      flexFields
      useStepCounter
      isCircleOnly
      isPublic
      rewardDisposition
      useAutoGoal
      autoGoalTimeframe
      autoGoalTimeframeCount
      autoGoalFactor
      minAutoGoal
      roundGoalPrecision
      advanceType
      nextMissionID
      topNumberAdvance
      useAutoCreate
      autoCreateTimeframe
      autoCreateTimeframeCount
      autoCreateStartDate
      autoCreateEndDate
      isHidden
      competitors
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      trophies {
        nextToken
        __typename
      }
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      tieKPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        doNotShow
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      missions {
        nextToken
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        __typename
      }
      circles {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateMission = /* GraphQL */ `
  mutation UpdateMission(
    $input: UpdateMissionInput!
    $condition: ModelMissionConditionInput
  ) {
    updateMission(input: $input, condition: $condition) {
      id
      type
      contestType
      name
      description
      rewardLimit
      rewardCount
      rewardType
      actionPastTense
      actionTypePlural
      rewardID
      rewardName
      scope
      ownerID
      ownerType
      startDate
      endDate
      launchDate
      startDateEpoch
      endDateEpoch
      launchDateEpoch
      KPIRuleID
      tieKPIRuleID
      imageName
      imageType
      questType
      questOrder
      location
      actionCount
      action
      actionType
      minGoal
      actionCountType
      completePictureRequired
      isDeleted
      nextLaunchFeedBlast
      nextExpireFeedBlast
      tags
      rules {
        id
        multiplier
        name
        role
        goal
        sequence
        __typename
      }
      bracket
      orgID
      mostRecentUserID
      trophiesAwarded
      rewardsAwarded
      bracketWinner
      autoAssign
      assignToChildCircles
      autoCreateMonths
      permissions
      categoryID
      flexFields
      useStepCounter
      isCircleOnly
      isPublic
      rewardDisposition
      useAutoGoal
      autoGoalTimeframe
      autoGoalTimeframeCount
      autoGoalFactor
      minAutoGoal
      roundGoalPrecision
      advanceType
      nextMissionID
      topNumberAdvance
      useAutoCreate
      autoCreateTimeframe
      autoCreateTimeframeCount
      autoCreateStartDate
      autoCreateEndDate
      isHidden
      competitors
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      trophies {
        nextToken
        __typename
      }
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      tieKPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        doNotShow
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      missions {
        nextToken
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        __typename
      }
      circles {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteMission = /* GraphQL */ `
  mutation DeleteMission(
    $input: DeleteMissionInput!
    $condition: ModelMissionConditionInput
  ) {
    deleteMission(input: $input, condition: $condition) {
      id
      type
      contestType
      name
      description
      rewardLimit
      rewardCount
      rewardType
      actionPastTense
      actionTypePlural
      rewardID
      rewardName
      scope
      ownerID
      ownerType
      startDate
      endDate
      launchDate
      startDateEpoch
      endDateEpoch
      launchDateEpoch
      KPIRuleID
      tieKPIRuleID
      imageName
      imageType
      questType
      questOrder
      location
      actionCount
      action
      actionType
      minGoal
      actionCountType
      completePictureRequired
      isDeleted
      nextLaunchFeedBlast
      nextExpireFeedBlast
      tags
      rules {
        id
        multiplier
        name
        role
        goal
        sequence
        __typename
      }
      bracket
      orgID
      mostRecentUserID
      trophiesAwarded
      rewardsAwarded
      bracketWinner
      autoAssign
      assignToChildCircles
      autoCreateMonths
      permissions
      categoryID
      flexFields
      useStepCounter
      isCircleOnly
      isPublic
      rewardDisposition
      useAutoGoal
      autoGoalTimeframe
      autoGoalTimeframeCount
      autoGoalFactor
      minAutoGoal
      roundGoalPrecision
      advanceType
      nextMissionID
      topNumberAdvance
      useAutoCreate
      autoCreateTimeframe
      autoCreateTimeframeCount
      autoCreateStartDate
      autoCreateEndDate
      isHidden
      competitors
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      trophies {
        nextToken
        __typename
      }
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      tieKPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        doNotShow
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      missions {
        nextToken
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        __typename
      }
      circles {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createMissionCategory = /* GraphQL */ `
  mutation CreateMissionCategory(
    $input: CreateMissionCategoryInput!
    $condition: ModelMissionCategoryConditionInput
  ) {
    createMissionCategory(input: $input, condition: $condition) {
      id
      orgID
      title
      iconName
      iconType
      iconColor
      isDefault
      doNotShow
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      missions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateMissionCategory = /* GraphQL */ `
  mutation UpdateMissionCategory(
    $input: UpdateMissionCategoryInput!
    $condition: ModelMissionCategoryConditionInput
  ) {
    updateMissionCategory(input: $input, condition: $condition) {
      id
      orgID
      title
      iconName
      iconType
      iconColor
      isDefault
      doNotShow
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      missions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteMissionCategory = /* GraphQL */ `
  mutation DeleteMissionCategory(
    $input: DeleteMissionCategoryInput!
    $condition: ModelMissionCategoryConditionInput
  ) {
    deleteMissionCategory(input: $input, condition: $condition) {
      id
      orgID
      title
      iconName
      iconType
      iconColor
      isDefault
      doNotShow
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      missions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createMissionReward = /* GraphQL */ `
  mutation CreateMissionReward(
    $input: CreateMissionRewardInput!
    $condition: ModelMissionRewardConditionInput
  ) {
    createMissionReward(input: $input, condition: $condition) {
      id
      orgID
      missionID
      rewardID
      points
      minActionCount
      place
      isTie
      awardedToIDs
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateMissionReward = /* GraphQL */ `
  mutation UpdateMissionReward(
    $input: UpdateMissionRewardInput!
    $condition: ModelMissionRewardConditionInput
  ) {
    updateMissionReward(input: $input, condition: $condition) {
      id
      orgID
      missionID
      rewardID
      points
      minActionCount
      place
      isTie
      awardedToIDs
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteMissionReward = /* GraphQL */ `
  mutation DeleteMissionReward(
    $input: DeleteMissionRewardInput!
    $condition: ModelMissionRewardConditionInput
  ) {
    deleteMissionReward(input: $input, condition: $condition) {
      id
      orgID
      missionID
      rewardID
      points
      minActionCount
      place
      isTie
      awardedToIDs
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createQuestMission = /* GraphQL */ `
  mutation CreateQuestMission(
    $input: CreateQuestMissionInput!
    $condition: ModelQuestMissionConditionInput
  ) {
    createQuestMission(input: $input, condition: $condition) {
      id
      questID
      missionID
      reservedByID
      reservationExpiration
      isComplete
      sequence
      permissions
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      quest {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateQuestMission = /* GraphQL */ `
  mutation UpdateQuestMission(
    $input: UpdateQuestMissionInput!
    $condition: ModelQuestMissionConditionInput
  ) {
    updateQuestMission(input: $input, condition: $condition) {
      id
      questID
      missionID
      reservedByID
      reservationExpiration
      isComplete
      sequence
      permissions
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      quest {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteQuestMission = /* GraphQL */ `
  mutation DeleteQuestMission(
    $input: DeleteQuestMissionInput!
    $condition: ModelQuestMissionConditionInput
  ) {
    deleteQuestMission(input: $input, condition: $condition) {
      id
      questID
      missionID
      reservedByID
      reservationExpiration
      isComplete
      sequence
      permissions
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      quest {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createCircle = /* GraphQL */ `
  mutation CreateCircle(
    $input: CreateCircleInput!
    $condition: ModelCircleConditionInput
  ) {
    createCircle(input: $input, condition: $condition) {
      id
      extID
      name
      sortName
      description
      location
      scope
      inviterType
      approverType
      status
      isActive
      isHidden
      imageName
      imageType
      avatarImageName
      communityID
      startDate
      endDate
      launchDate
      orgID
      nextLaunchFeedBlast
      nextExpireFeedBlast
      permissions
      parentCircleID
      levelID
      colorCode
      fieldRoutesOfficeID
      flexAttributes
      coordinates {
        lat
        lon
        __typename
      }
      tangoAccountID
      isLeague
      hasWanderMode
      hasRoundRobin
      defaultSchedulerID
      level {
        id
        name
        description
        levelNum
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      useRecordingConsent
      parent {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      children {
        nextToken
        __typename
      }
      preferences {
        nextToken
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        __typename
      }
      users {
        nextToken
        __typename
      }
      missions {
        nextToken
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateCircle = /* GraphQL */ `
  mutation UpdateCircle(
    $input: UpdateCircleInput!
    $condition: ModelCircleConditionInput
  ) {
    updateCircle(input: $input, condition: $condition) {
      id
      extID
      name
      sortName
      description
      location
      scope
      inviterType
      approverType
      status
      isActive
      isHidden
      imageName
      imageType
      avatarImageName
      communityID
      startDate
      endDate
      launchDate
      orgID
      nextLaunchFeedBlast
      nextExpireFeedBlast
      permissions
      parentCircleID
      levelID
      colorCode
      fieldRoutesOfficeID
      flexAttributes
      coordinates {
        lat
        lon
        __typename
      }
      tangoAccountID
      isLeague
      hasWanderMode
      hasRoundRobin
      defaultSchedulerID
      level {
        id
        name
        description
        levelNum
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      useRecordingConsent
      parent {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      children {
        nextToken
        __typename
      }
      preferences {
        nextToken
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        __typename
      }
      users {
        nextToken
        __typename
      }
      missions {
        nextToken
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteCircle = /* GraphQL */ `
  mutation DeleteCircle(
    $input: DeleteCircleInput!
    $condition: ModelCircleConditionInput
  ) {
    deleteCircle(input: $input, condition: $condition) {
      id
      extID
      name
      sortName
      description
      location
      scope
      inviterType
      approverType
      status
      isActive
      isHidden
      imageName
      imageType
      avatarImageName
      communityID
      startDate
      endDate
      launchDate
      orgID
      nextLaunchFeedBlast
      nextExpireFeedBlast
      permissions
      parentCircleID
      levelID
      colorCode
      fieldRoutesOfficeID
      flexAttributes
      coordinates {
        lat
        lon
        __typename
      }
      tangoAccountID
      isLeague
      hasWanderMode
      hasRoundRobin
      defaultSchedulerID
      level {
        id
        name
        description
        levelNum
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      useRecordingConsent
      parent {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      children {
        nextToken
        __typename
      }
      preferences {
        nextToken
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        __typename
      }
      users {
        nextToken
        __typename
      }
      missions {
        nextToken
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      extID
      username
      email
      phoneNumber
      name
      birthdate
      imageName
      imageType
      location
      nameVisibility
      phoneNumberVisibility
      emailVisibility
      birthdateVisibility
      pictureVisibility
      locationVisibility
      initials
      pronoun
      role
      functionalRoles
      status
      expoToken
      orgID
      title
      externalTitle
      externalPhoneNumber
      externalBio
      socials {
        type
        uri
        __typename
      }
      categories
      avatarID
      levelID
      circleLevel {
        id
        name
        description
        levelNum
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      agreedToTerms
      agreedToTermsAt
      tags
      colorCode
      hasWanderMode
      hasRoundRobin
      flexAttributes
      defaultCategoryID
      allowedCategoryIDs
      stripeCustomerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      lessonAssignments {
        nextToken
        __typename
      }
      PersonDefaultSchedules {
        nextToken
        __typename
      }
      PersonScheduleOverrides {
        nextToken
        __typename
      }
      PersonAppointments {
        nextToken
        __typename
      }
      SetterAppointments {
        nextToken
        __typename
      }
      addresses {
        nextToken
        __typename
      }
      trophies {
        nextToken
        __typename
      }
      kpis {
        nextToken
        __typename
      }
      orgs {
        nextToken
        __typename
      }
      circles {
        nextToken
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      extID
      username
      email
      phoneNumber
      name
      birthdate
      imageName
      imageType
      location
      nameVisibility
      phoneNumberVisibility
      emailVisibility
      birthdateVisibility
      pictureVisibility
      locationVisibility
      initials
      pronoun
      role
      functionalRoles
      status
      expoToken
      orgID
      title
      externalTitle
      externalPhoneNumber
      externalBio
      socials {
        type
        uri
        __typename
      }
      categories
      avatarID
      levelID
      circleLevel {
        id
        name
        description
        levelNum
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      agreedToTerms
      agreedToTermsAt
      tags
      colorCode
      hasWanderMode
      hasRoundRobin
      flexAttributes
      defaultCategoryID
      allowedCategoryIDs
      stripeCustomerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      lessonAssignments {
        nextToken
        __typename
      }
      PersonDefaultSchedules {
        nextToken
        __typename
      }
      PersonScheduleOverrides {
        nextToken
        __typename
      }
      PersonAppointments {
        nextToken
        __typename
      }
      SetterAppointments {
        nextToken
        __typename
      }
      addresses {
        nextToken
        __typename
      }
      trophies {
        nextToken
        __typename
      }
      kpis {
        nextToken
        __typename
      }
      orgs {
        nextToken
        __typename
      }
      circles {
        nextToken
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      extID
      username
      email
      phoneNumber
      name
      birthdate
      imageName
      imageType
      location
      nameVisibility
      phoneNumberVisibility
      emailVisibility
      birthdateVisibility
      pictureVisibility
      locationVisibility
      initials
      pronoun
      role
      functionalRoles
      status
      expoToken
      orgID
      title
      externalTitle
      externalPhoneNumber
      externalBio
      socials {
        type
        uri
        __typename
      }
      categories
      avatarID
      levelID
      circleLevel {
        id
        name
        description
        levelNum
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      agreedToTerms
      agreedToTermsAt
      tags
      colorCode
      hasWanderMode
      hasRoundRobin
      flexAttributes
      defaultCategoryID
      allowedCategoryIDs
      stripeCustomerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      lessonAssignments {
        nextToken
        __typename
      }
      PersonDefaultSchedules {
        nextToken
        __typename
      }
      PersonScheduleOverrides {
        nextToken
        __typename
      }
      PersonAppointments {
        nextToken
        __typename
      }
      SetterAppointments {
        nextToken
        __typename
      }
      addresses {
        nextToken
        __typename
      }
      trophies {
        nextToken
        __typename
      }
      kpis {
        nextToken
        __typename
      }
      orgs {
        nextToken
        __typename
      }
      circles {
        nextToken
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createCompany = /* GraphQL */ `
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    createCompany(input: $input, condition: $condition) {
      id
      orgID
      name
      phoneNumber
      website
      currentOwnerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      Contacts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      id
      orgID
      name
      phoneNumber
      website
      currentOwnerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      Contacts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany(
    $input: DeleteCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    deleteCompany(input: $input, condition: $condition) {
      id
      orgID
      name
      phoneNumber
      website
      currentOwnerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      Contacts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createContactList = /* GraphQL */ `
  mutation CreateContactList(
    $input: CreateContactListInput!
    $condition: ModelContactListConditionInput
  ) {
    createContactList(input: $input, condition: $condition) {
      id
      orgID
      name
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      members {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateContactList = /* GraphQL */ `
  mutation UpdateContactList(
    $input: UpdateContactListInput!
    $condition: ModelContactListConditionInput
  ) {
    updateContactList(input: $input, condition: $condition) {
      id
      orgID
      name
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      members {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteContactList = /* GraphQL */ `
  mutation DeleteContactList(
    $input: DeleteContactListInput!
    $condition: ModelContactListConditionInput
  ) {
    deleteContactList(input: $input, condition: $condition) {
      id
      orgID
      name
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      members {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createContactMember = /* GraphQL */ `
  mutation CreateContactMember(
    $input: CreateContactMemberInput!
    $condition: ModelContactMemberConditionInput
  ) {
    createContactMember(input: $input, condition: $condition) {
      id
      orgID
      contactListID
      contactID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      contactList {
        id
        orgID
        name
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      contact {
        id
        orgID
        companyID
        relatedContactID
        relationshipType
        firstName
        lastName
        phoneNumber
        email
        currentOwnerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateContactMember = /* GraphQL */ `
  mutation UpdateContactMember(
    $input: UpdateContactMemberInput!
    $condition: ModelContactMemberConditionInput
  ) {
    updateContactMember(input: $input, condition: $condition) {
      id
      orgID
      contactListID
      contactID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      contactList {
        id
        orgID
        name
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      contact {
        id
        orgID
        companyID
        relatedContactID
        relationshipType
        firstName
        lastName
        phoneNumber
        email
        currentOwnerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteContactMember = /* GraphQL */ `
  mutation DeleteContactMember(
    $input: DeleteContactMemberInput!
    $condition: ModelContactMemberConditionInput
  ) {
    deleteContactMember(input: $input, condition: $condition) {
      id
      orgID
      contactListID
      contactID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      contactList {
        id
        orgID
        name
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      contact {
        id
        orgID
        companyID
        relatedContactID
        relationshipType
        firstName
        lastName
        phoneNumber
        email
        currentOwnerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createContact = /* GraphQL */ `
  mutation CreateContact(
    $input: CreateContactInput!
    $condition: ModelContactConditionInput
  ) {
    createContact(input: $input, condition: $condition) {
      id
      orgID
      companyID
      relatedContactID
      relationshipType
      firstName
      lastName
      phoneNumber
      email
      currentOwnerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      lists {
        nextToken
        __typename
      }
      RelatedContacts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateContact = /* GraphQL */ `
  mutation UpdateContact(
    $input: UpdateContactInput!
    $condition: ModelContactConditionInput
  ) {
    updateContact(input: $input, condition: $condition) {
      id
      orgID
      companyID
      relatedContactID
      relationshipType
      firstName
      lastName
      phoneNumber
      email
      currentOwnerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      lists {
        nextToken
        __typename
      }
      RelatedContacts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteContact = /* GraphQL */ `
  mutation DeleteContact(
    $input: DeleteContactInput!
    $condition: ModelContactConditionInput
  ) {
    deleteContact(input: $input, condition: $condition) {
      id
      orgID
      companyID
      relatedContactID
      relationshipType
      firstName
      lastName
      phoneNumber
      email
      currentOwnerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      lists {
        nextToken
        __typename
      }
      RelatedContacts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createPreferences = /* GraphQL */ `
  mutation CreatePreferences(
    $input: CreatePreferencesInput!
    $condition: ModelPreferencesConditionInput
  ) {
    createPreferences(input: $input, condition: $condition) {
      id
      orgID
      isHidden
      preferenceType
      name
      entityType
      entityID
      preferences
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePreferences = /* GraphQL */ `
  mutation UpdatePreferences(
    $input: UpdatePreferencesInput!
    $condition: ModelPreferencesConditionInput
  ) {
    updatePreferences(input: $input, condition: $condition) {
      id
      orgID
      isHidden
      preferenceType
      name
      entityType
      entityID
      preferences
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePreferences = /* GraphQL */ `
  mutation DeletePreferences(
    $input: DeletePreferencesInput!
    $condition: ModelPreferencesConditionInput
  ) {
    deletePreferences(input: $input, condition: $condition) {
      id
      orgID
      isHidden
      preferenceType
      name
      entityType
      entityID
      preferences
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrg = /* GraphQL */ `
  mutation CreateOrg(
    $input: CreateOrgInput!
    $condition: ModelOrgConditionInput
  ) {
    createOrg(input: $input, condition: $condition) {
      id
      stripeID
      gamifyBundle
      name
      domains
      contactEmail
      contactName
      contactAddress
      contactAddress2
      contactCity
      contactState
      contactZip
      contactPhone
      configParms
      hubspotID
      countryCode
      integrations
      restrictionType
      permissions
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      docuSealAccess
      circles {
        nextToken
        __typename
      }
      preferences {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateOrg = /* GraphQL */ `
  mutation UpdateOrg(
    $input: UpdateOrgInput!
    $condition: ModelOrgConditionInput
  ) {
    updateOrg(input: $input, condition: $condition) {
      id
      stripeID
      gamifyBundle
      name
      domains
      contactEmail
      contactName
      contactAddress
      contactAddress2
      contactCity
      contactState
      contactZip
      contactPhone
      configParms
      hubspotID
      countryCode
      integrations
      restrictionType
      permissions
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      docuSealAccess
      companyLogo
      coverPhoto
      legalBusinessName
      dbaName
      legalEntityType
      einTaxId
      statesOfOperation
      insuranceContactName
      insuranceContactTitle
      insuranceContactPhone
      insuranceContactEmail
      licenseNumber
      licenseIssuingState
      licenseExpirationDate
      defaultEstimateDisclaimer
      standardScopeNotes
      circles {
        nextToken
        __typename
      }
      preferences {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteOrg = /* GraphQL */ `
  mutation DeleteOrg(
    $input: DeleteOrgInput!
    $condition: ModelOrgConditionInput
  ) {
    deleteOrg(input: $input, condition: $condition) {
      id
      stripeID
      gamifyBundle
      name
      domains
      contactEmail
      contactName
      contactAddress
      contactAddress2
      contactCity
      contactState
      contactZip
      contactPhone
      configParms
      hubspotID
      countryCode
      integrations
      restrictionType
      permissions
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      docuSealAccess
      circles {
        nextToken
        __typename
      }
      preferences {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createOrgMember = /* GraphQL */ `
  mutation CreateOrgMember(
    $input: CreateOrgMemberInput!
    $condition: ModelOrgMemberConditionInput
  ) {
    createOrgMember(input: $input, condition: $condition) {
      id
      userID
      roleID
      orgID
      status
      memberType
      orgPoints
      lifetimeOrgPoints
      isActive
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        __typename
      }
      __typename
    }
  }
`;
export const updateOrgMember = /* GraphQL */ `
  mutation UpdateOrgMember(
    $input: UpdateOrgMemberInput!
    $condition: ModelOrgMemberConditionInput
  ) {
    updateOrgMember(input: $input, condition: $condition) {
      id
      userID
      roleID
      orgID
      status
      memberType
      orgPoints
      lifetimeOrgPoints
      isActive
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        __typename
      }
      __typename
    }
  }
`;
export const deleteOrgMember = /* GraphQL */ `
  mutation DeleteOrgMember(
    $input: DeleteOrgMemberInput!
    $condition: ModelOrgMemberConditionInput
  ) {
    deleteOrgMember(input: $input, condition: $condition) {
      id
      userID
      roleID
      orgID
      status
      memberType
      orgPoints
      lifetimeOrgPoints
      isActive
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        __typename
      }
      __typename
    }
  }
`;
export const createCircleMember = /* GraphQL */ `
  mutation CreateCircleMember(
    $input: CreateCircleMemberInput!
    $condition: ModelCircleMemberConditionInput
  ) {
    createCircleMember(input: $input, condition: $condition) {
      id
      userID
      circleID
      status
      memberType
      closerOrder
      closerWeight
      appointmentCount
      memberRole
      priority
      circlePoints
      lifetimeCirclePoints
      isActive
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateCircleMember = /* GraphQL */ `
  mutation UpdateCircleMember(
    $input: UpdateCircleMemberInput!
    $condition: ModelCircleMemberConditionInput
  ) {
    updateCircleMember(input: $input, condition: $condition) {
      id
      userID
      circleID
      status
      memberType
      closerOrder
      closerWeight
      appointmentCount
      memberRole
      priority
      circlePoints
      lifetimeCirclePoints
      isActive
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteCircleMember = /* GraphQL */ `
  mutation DeleteCircleMember(
    $input: DeleteCircleMemberInput!
    $condition: ModelCircleMemberConditionInput
  ) {
    deleteCircleMember(input: $input, condition: $condition) {
      id
      userID
      circleID
      status
      memberType
      closerOrder
      closerWeight
      appointmentCount
      memberRole
      priority
      circlePoints
      lifetimeCirclePoints
      isActive
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createCircleMission = /* GraphQL */ `
  mutation CreateCircleMission(
    $input: CreateCircleMissionInput!
    $condition: ModelCircleMissionConditionInput
  ) {
    createCircleMission(input: $input, condition: $condition) {
      id
      circleID
      orgID
      startDate
      endDate
      missionID
      isPaid
      currentPosition
      previousPosition
      rewardDisposition
      doneActionCount
      goalActionCount
      rewardCount
      trophiesAwarded
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      __typename
    }
  }
`;
export const updateCircleMission = /* GraphQL */ `
  mutation UpdateCircleMission(
    $input: UpdateCircleMissionInput!
    $condition: ModelCircleMissionConditionInput
  ) {
    updateCircleMission(input: $input, condition: $condition) {
      id
      circleID
      orgID
      startDate
      endDate
      missionID
      isPaid
      currentPosition
      previousPosition
      rewardDisposition
      doneActionCount
      goalActionCount
      rewardCount
      trophiesAwarded
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      __typename
    }
  }
`;
export const deleteCircleMission = /* GraphQL */ `
  mutation DeleteCircleMission(
    $input: DeleteCircleMissionInput!
    $condition: ModelCircleMissionConditionInput
  ) {
    deleteCircleMission(input: $input, condition: $condition) {
      id
      circleID
      orgID
      startDate
      endDate
      missionID
      isPaid
      currentPosition
      previousPosition
      rewardDisposition
      doneActionCount
      goalActionCount
      rewardCount
      trophiesAwarded
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      __typename
    }
  }
`;
export const createUserMission = /* GraphQL */ `
  mutation CreateUserMission(
    $input: CreateUserMissionInput!
    $condition: ModelUserMissionConditionInput
  ) {
    createUserMission(input: $input, condition: $condition) {
      id
      userID
      playMission
      missionID
      circleID
      status
      isCompleted
      isVerified
      isPaid
      imageName
      imageType
      doneActionCount
      goalActionCount
      location
      rewardCount
      rewardDisposition
      currentPosition
      previousPosition
      permissions
      orgID
      KPIRuleID
      action
      startDate
      endDate
      launchDate
      startDateEpoch
      endDateEpoch
      launchDateEpoch
      flexFields
      useStepCounter
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      actions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateUserMission = /* GraphQL */ `
  mutation UpdateUserMission(
    $input: UpdateUserMissionInput!
    $condition: ModelUserMissionConditionInput
  ) {
    updateUserMission(input: $input, condition: $condition) {
      id
      userID
      playMission
      missionID
      circleID
      status
      isCompleted
      isVerified
      isPaid
      imageName
      imageType
      doneActionCount
      goalActionCount
      location
      rewardCount
      rewardDisposition
      currentPosition
      previousPosition
      permissions
      orgID
      KPIRuleID
      action
      startDate
      endDate
      launchDate
      startDateEpoch
      endDateEpoch
      launchDateEpoch
      flexFields
      useStepCounter
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      actions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserMission = /* GraphQL */ `
  mutation DeleteUserMission(
    $input: DeleteUserMissionInput!
    $condition: ModelUserMissionConditionInput
  ) {
    deleteUserMission(input: $input, condition: $condition) {
      id
      userID
      playMission
      missionID
      circleID
      status
      isCompleted
      isVerified
      isPaid
      imageName
      imageType
      doneActionCount
      goalActionCount
      location
      rewardCount
      rewardDisposition
      currentPosition
      previousPosition
      permissions
      orgID
      KPIRuleID
      action
      startDate
      endDate
      launchDate
      startDateEpoch
      endDateEpoch
      launchDateEpoch
      flexFields
      useStepCounter
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      actions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createUserMissionAction = /* GraphQL */ `
  mutation CreateUserMissionAction(
    $input: CreateUserMissionActionInput!
    $condition: ModelUserMissionActionConditionInput
  ) {
    createUserMissionAction(input: $input, condition: $condition) {
      id
      userMissionID
      userID
      missionID
      ownerID
      KPIRuleID
      ruleRole
      actionCount
      currentActionCount
      rewardCount
      currentRewardCount
      comments
      imageName
      imageType
      extID
      dealID
      flexAttributes
      goalCount
      actionTimestamp
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      userMission {
        id
        userID
        playMission
        missionID
        circleID
        status
        isCompleted
        isVerified
        isPaid
        imageName
        imageType
        doneActionCount
        goalActionCount
        location
        rewardCount
        rewardDisposition
        currentPosition
        previousPosition
        permissions
        orgID
        KPIRuleID
        action
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        flexFields
        useStepCounter
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateUserMissionAction = /* GraphQL */ `
  mutation UpdateUserMissionAction(
    $input: UpdateUserMissionActionInput!
    $condition: ModelUserMissionActionConditionInput
  ) {
    updateUserMissionAction(input: $input, condition: $condition) {
      id
      userMissionID
      userID
      missionID
      ownerID
      KPIRuleID
      ruleRole
      actionCount
      currentActionCount
      rewardCount
      currentRewardCount
      comments
      imageName
      imageType
      extID
      dealID
      flexAttributes
      goalCount
      actionTimestamp
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      userMission {
        id
        userID
        playMission
        missionID
        circleID
        status
        isCompleted
        isVerified
        isPaid
        imageName
        imageType
        doneActionCount
        goalActionCount
        location
        rewardCount
        rewardDisposition
        currentPosition
        previousPosition
        permissions
        orgID
        KPIRuleID
        action
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        flexFields
        useStepCounter
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserMissionAction = /* GraphQL */ `
  mutation DeleteUserMissionAction(
    $input: DeleteUserMissionActionInput!
    $condition: ModelUserMissionActionConditionInput
  ) {
    deleteUserMissionAction(input: $input, condition: $condition) {
      id
      userMissionID
      userID
      missionID
      ownerID
      KPIRuleID
      ruleRole
      actionCount
      currentActionCount
      rewardCount
      currentRewardCount
      comments
      imageName
      imageType
      extID
      dealID
      flexAttributes
      goalCount
      actionTimestamp
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      userMission {
        id
        userID
        playMission
        missionID
        circleID
        status
        isCompleted
        isVerified
        isPaid
        imageName
        imageType
        doneActionCount
        goalActionCount
        location
        rewardCount
        rewardDisposition
        currentPosition
        previousPosition
        permissions
        orgID
        KPIRuleID
        action
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        flexFields
        useStepCounter
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createReward = /* GraphQL */ `
  mutation CreateReward(
    $input: CreateRewardInput!
    $condition: ModelRewardConditionInput
  ) {
    createReward(input: $input, condition: $condition) {
      id
      name
      description
      rewardType
      personLimit
      limitCount
      value
      valueType
      remainingCount
      imageName
      imageType
      tags
      validFrom
      validTo
      launchDate
      isActive
      cost
      costType
      giftcardValue
      minGiftcardAmount
      maxGiftcardAmount
      utid
      tangoAccountID
      ownerType
      ownerID
      approverType
      location
      giftcardDisclaimer
      orgID
      nextLaunchFeedBlast
      nextExpireFeedBlast
      permissions
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      missions {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      userdetails {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateReward = /* GraphQL */ `
  mutation UpdateReward(
    $input: UpdateRewardInput!
    $condition: ModelRewardConditionInput
  ) {
    updateReward(input: $input, condition: $condition) {
      id
      name
      description
      rewardType
      personLimit
      limitCount
      value
      valueType
      remainingCount
      imageName
      imageType
      tags
      validFrom
      validTo
      launchDate
      isActive
      cost
      costType
      giftcardValue
      minGiftcardAmount
      maxGiftcardAmount
      utid
      tangoAccountID
      ownerType
      ownerID
      approverType
      location
      giftcardDisclaimer
      orgID
      nextLaunchFeedBlast
      nextExpireFeedBlast
      permissions
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      missions {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      userdetails {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteReward = /* GraphQL */ `
  mutation DeleteReward(
    $input: DeleteRewardInput!
    $condition: ModelRewardConditionInput
  ) {
    deleteReward(input: $input, condition: $condition) {
      id
      name
      description
      rewardType
      personLimit
      limitCount
      value
      valueType
      remainingCount
      imageName
      imageType
      tags
      validFrom
      validTo
      launchDate
      isActive
      cost
      costType
      giftcardValue
      minGiftcardAmount
      maxGiftcardAmount
      utid
      tangoAccountID
      ownerType
      ownerID
      approverType
      location
      giftcardDisclaimer
      orgID
      nextLaunchFeedBlast
      nextExpireFeedBlast
      permissions
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      missions {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      userdetails {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createUserReward = /* GraphQL */ `
  mutation CreateUserReward(
    $input: CreateUserRewardInput!
    $condition: ModelUserRewardConditionInput
  ) {
    createUserReward(input: $input, condition: $condition) {
      id
      userID
      rewardID
      purchaseType
      status
      purchaseCount
      permissions
      orgID
      approverID
      errorMessages
      statusTmst
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      details {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateUserReward = /* GraphQL */ `
  mutation UpdateUserReward(
    $input: UpdateUserRewardInput!
    $condition: ModelUserRewardConditionInput
  ) {
    updateUserReward(input: $input, condition: $condition) {
      id
      userID
      rewardID
      purchaseType
      status
      purchaseCount
      permissions
      orgID
      approverID
      errorMessages
      statusTmst
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      details {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserReward = /* GraphQL */ `
  mutation DeleteUserReward(
    $input: DeleteUserRewardInput!
    $condition: ModelUserRewardConditionInput
  ) {
    deleteUserReward(input: $input, condition: $condition) {
      id
      userID
      rewardID
      purchaseType
      status
      purchaseCount
      permissions
      orgID
      approverID
      errorMessages
      statusTmst
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      details {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createUserLocation = /* GraphQL */ `
  mutation CreateUserLocation(
    $input: CreateUserLocationInput!
    $condition: ModelUserLocationConditionInput
  ) {
    createUserLocation(input: $input, condition: $condition) {
      id
      userID
      orgID
      location {
        lat
        lon
        __typename
      }
      batteryLevel
      deviceInfo
      appVersion
      transactionCounts
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateUserLocation = /* GraphQL */ `
  mutation UpdateUserLocation(
    $input: UpdateUserLocationInput!
    $condition: ModelUserLocationConditionInput
  ) {
    updateUserLocation(input: $input, condition: $condition) {
      id
      userID
      orgID
      location {
        lat
        lon
        __typename
      }
      batteryLevel
      deviceInfo
      appVersion
      transactionCounts
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserLocation = /* GraphQL */ `
  mutation DeleteUserLocation(
    $input: DeleteUserLocationInput!
    $condition: ModelUserLocationConditionInput
  ) {
    deleteUserLocation(input: $input, condition: $condition) {
      id
      userID
      orgID
      location {
        lat
        lon
        __typename
      }
      batteryLevel
      deviceInfo
      appVersion
      transactionCounts
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createLeadTransaction = /* GraphQL */ `
  mutation CreateLeadTransaction(
    $input: CreateLeadTransactionInput!
    $condition: ModelLeadTransactionConditionInput
  ) {
    createLeadTransaction(input: $input, condition: $condition) {
      id
      leadAreaID
      leadArea {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      orgID
      transactionType
      transactionDate
      amount
      currency
      stripeTransactionID
      stripePaymentIntentID
      status
      metadata
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const updateLeadTransaction = /* GraphQL */ `
  mutation UpdateLeadTransaction(
    $input: UpdateLeadTransactionInput!
    $condition: ModelLeadTransactionConditionInput
  ) {
    updateLeadTransaction(input: $input, condition: $condition) {
      id
      leadAreaID
      leadArea {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      orgID
      transactionType
      transactionDate
      amount
      currency
      stripeTransactionID
      stripePaymentIntentID
      status
      metadata
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const deleteLeadTransaction = /* GraphQL */ `
  mutation DeleteLeadTransaction(
    $input: DeleteLeadTransactionInput!
    $condition: ModelLeadTransactionConditionInput
  ) {
    deleteLeadTransaction(input: $input, condition: $condition) {
      id
      leadAreaID
      leadArea {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      orgID
      transactionType
      transactionDate
      amount
      currency
      stripeTransactionID
      stripePaymentIntentID
      status
      metadata
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const createUserRewardDetails = /* GraphQL */ `
  mutation CreateUserRewardDetails(
    $input: CreateUserRewardDetailsInput!
    $condition: ModelUserRewardDetailsConditionInput
  ) {
    createUserRewardDetails(input: $input, condition: $condition) {
      id
      userRewardID
      userID
      rewardID
      orgID
      missionID
      purchaseType
      status
      errorMessages
      statusTmst
      purchaseCount
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      userReward {
        id
        userID
        rewardID
        purchaseType
        status
        purchaseCount
        permissions
        orgID
        approverID
        errorMessages
        statusTmst
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateUserRewardDetails = /* GraphQL */ `
  mutation UpdateUserRewardDetails(
    $input: UpdateUserRewardDetailsInput!
    $condition: ModelUserRewardDetailsConditionInput
  ) {
    updateUserRewardDetails(input: $input, condition: $condition) {
      id
      userRewardID
      userID
      rewardID
      orgID
      missionID
      purchaseType
      status
      errorMessages
      statusTmst
      purchaseCount
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      userReward {
        id
        userID
        rewardID
        purchaseType
        status
        purchaseCount
        permissions
        orgID
        approverID
        errorMessages
        statusTmst
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserRewardDetails = /* GraphQL */ `
  mutation DeleteUserRewardDetails(
    $input: DeleteUserRewardDetailsInput!
    $condition: ModelUserRewardDetailsConditionInput
  ) {
    deleteUserRewardDetails(input: $input, condition: $condition) {
      id
      userRewardID
      userID
      rewardID
      orgID
      missionID
      purchaseType
      status
      errorMessages
      statusTmst
      purchaseCount
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      userReward {
        id
        userID
        rewardID
        purchaseType
        status
        purchaseCount
        permissions
        orgID
        approverID
        errorMessages
        statusTmst
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createUserGiftcardAccount = /* GraphQL */ `
  mutation CreateUserGiftcardAccount(
    $input: CreateUserGiftcardAccountInput!
    $condition: ModelUserGiftcardAccountConditionInput
  ) {
    createUserGiftcardAccount(input: $input, condition: $condition) {
      id
      userID
      orgID
      name
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circles {
        nextToken
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateUserGiftcardAccount = /* GraphQL */ `
  mutation UpdateUserGiftcardAccount(
    $input: UpdateUserGiftcardAccountInput!
    $condition: ModelUserGiftcardAccountConditionInput
  ) {
    updateUserGiftcardAccount(input: $input, condition: $condition) {
      id
      userID
      orgID
      name
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circles {
        nextToken
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserGiftcardAccount = /* GraphQL */ `
  mutation DeleteUserGiftcardAccount(
    $input: DeleteUserGiftcardAccountInput!
    $condition: ModelUserGiftcardAccountConditionInput
  ) {
    deleteUserGiftcardAccount(input: $input, condition: $condition) {
      id
      userID
      orgID
      name
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circles {
        nextToken
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createUserTask = /* GraphQL */ `
  mutation CreateUserTask(
    $input: CreateUserTaskInput!
    $condition: ModelUserTaskConditionInput
  ) {
    createUserTask(input: $input, condition: $condition) {
      id
      orgID
      userID
      dueDate
      expire
      dealID
      createdBy
      completedTmst
      title
      description
      isCompleted
      isRead
      priority
      isArchived
      flexAttributes
      isDeleted
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const updateUserTask = /* GraphQL */ `
  mutation UpdateUserTask(
    $input: UpdateUserTaskInput!
    $condition: ModelUserTaskConditionInput
  ) {
    updateUserTask(input: $input, condition: $condition) {
      id
      orgID
      userID
      dueDate
      expire
      dealID
      createdBy
      completedTmst
      title
      description
      isCompleted
      isRead
      priority
      isArchived
      flexAttributes
      isDeleted
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserTask = /* GraphQL */ `
  mutation DeleteUserTask(
    $input: DeleteUserTaskInput!
    $condition: ModelUserTaskConditionInput
  ) {
    deleteUserTask(input: $input, condition: $condition) {
      id
      orgID
      userID
      dueDate
      expire
      dealID
      createdBy
      completedTmst
      title
      description
      isCompleted
      isRead
      priority
      isArchived
      flexAttributes
      isDeleted
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const createUserRole = /* GraphQL */ `
  mutation CreateUserRole(
    $input: CreateUserRoleInput!
    $condition: ModelUserRoleConditionInput
  ) {
    createUserRole(input: $input, condition: $condition) {
      id
      orgID
      isDeleted
      roleName
      permissions
      isSuper
      iconName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserRole = /* GraphQL */ `
  mutation UpdateUserRole(
    $input: UpdateUserRoleInput!
    $condition: ModelUserRoleConditionInput
  ) {
    updateUserRole(input: $input, condition: $condition) {
      id
      orgID
      isDeleted
      roleName
      permissions
      isSuper
      iconName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserRole = /* GraphQL */ `
  mutation DeleteUserRole(
    $input: DeleteUserRoleInput!
    $condition: ModelUserRoleConditionInput
  ) {
    deleteUserRole(input: $input, condition: $condition) {
      id
      orgID
      isDeleted
      roleName
      permissions
      isSuper
      iconName
      createdAt
      updatedAt
      __typename
    }
  }
`;
